package com.downdogapp.client

/**
 * AUTO-GENERATED DO NOT EDIT!
 * from com.downdogapp.tasks.AppStrings
 */
// @formatter:off 
object UkrainianStrings : LanguageStrings {
  // https://worker.downdogapp.com/debug/appString?appStringId=488
  override fun ABBREVIATED_MEMBERSHIP_WILL_NOT_RENEW(p0: Any) = "Скасовано, закінчується ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=498
  override val ACCOUNT = "Обліковий запис"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2588
  override val ACCOUNT_INELIGIBLE_FOR_REFERRAL_MESSAGE = "Схоже, у вас вже є обліковий запис! Лише нові облікові записи мають право на безкоштовне членство за реферальною програмою. Вибачте!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3956
  override val ACTIVITY = "Активність"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1467
  override val AFFILIATE_ANSWER = "Дякуємо за ваш інтерес! Ми припинили нашу партнерську програму, тому, на жаль, ні. Вибачте!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1466
  override val AFFILIATE_QUESTION = "Чи маєте ви реферальну або партнерську програму?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1299
  override val AFFORDABILITY = "Доступність"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1300
  override val AFFORDABILITY_FEEDBACK_PROMPT = "Розкажіть нам про вашу ситуацію"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=518
  override val AFFORDABILITY_MESSAGE = "Наша місія – надавати чудовий доступний фітнес усьому світу. Якщо Down Dog зараз не входить у ваш бюджет, надішліть нам повідомлення з поясненням вашої ситуації, і ми подивимося, що можемо зробити!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3973
  override val AFFORDABILITY_SUPPORT_PAGE_TITLE = "Не можете собі дозволити?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3950
  override val AIRPLAY = "Airplay"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1409
  override val AIRPLAY_ANSWER = "Ви можете транслювати свою практику Down Dog за допомогою дзеркального відображення екрана! Для отримання додаткової інформації перейдіть на <a href=\"https://support.apple.com/en-us/HT204289\">сторінку підтримки Apple</a>"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1408
  override val AIRPLAY_QUESTION = "Чи підтримуєте ви AirPlay?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1292
  override val ALL = "Усі"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1255
  override val ALL_APPS = "Усі додатки"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1453
  override val ALL_APPS_PURCHASE_ANSWER = "На даний момент підписка надає вам доступ до всіх наших додатків, включаючи Down Dog Yoga, HIIT, Barre, Prenatal Yoga та Meditation!\n\nМи наразі не пропонуємо можливість придбати окремий додаток."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1452
  override val ALL_APPS_PURCHASE_QUESTION = "Чи моя підписка діє для одного додатку чи для всіх додатків?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3110
  override val ALL_POSES = "Усі пози"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1295
  override fun AMOUNTS_CURRENCY_PAYMENTS_SECURE_MESSAGE(p0: Any) = "Усі суми вказані в ${p0}. Ваші платіжні дані зашифровані та захищені."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=113
  override val AND = "і"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1589
  override val APPLE = "Apple"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1403
  override val APPLE_HEALTH_ANSWER = "Так! Якщо у вас виникають проблеми з підключенням, ось кілька порад:\n1. Перевірте, чи ваш додаток підключений до Health. Відкрийте додаток і перейдіть до меню (натисніть кнопку з трьома горизонтальними лініями внизу праворуч), чи є там опція Підключитися до Apple Health? Якщо так, натисніть цю опцію.\n2. Відкрийте додаток Health на вашому телефоні та натисніть вкладку джерел даних. Чи вказаний Down Dog як джерело даних? Це для того, щоб переконатися, що Down Dog підключений. Якщо ні (але не було опції підключення в Down Dog), повідомте нам!\n3. Спробуйте видалити та перевстановити додаток, а потім увійти в систему та знову підключитися до Apple Health.\n\nНа жаль, Apple Health не підтримується на iPad, і ми не підтримуємо відстеження ваших практик на різних пристроях (хоча, можливо, колись будемо)."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1402
  override val APPLE_HEALTH_QUESTION = "Чи підключаються додатки до Apple Health?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1420
  override fun APPLE_REFUND_POLICY(p0: Any) = "На жаль, Apple не дозволяє нам скасовувати або повертати кошти за підписки, придбані через App Store. Ось деякі інструкції від Apple щодо того, як скасувати вашу підписку: ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1425
  override val ASK_IN_FACEBOOK_GROUP = "Запитайте у групі на Facebook"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=490
  override val AUTO_RENEW_IS_OFF = "Автопоновлення вимкнено"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=489
  override val AUTO_RENEW_IS_ON = "Автопоновлення увімкнено"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1221
  override val AUTO_RENEW_OFF_ANSWER = "<b>Як керувати або скасувати підписку</b>\n\nЯкщо ви придбали підписку <em>на веб-сайті</em>:\n1. Перейдіть до <b>Налаштувань</b>. На мобільному пристрої ви можете потрапити туди, натиснувши три горизонтальні лінії внизу праворуч на екрані. На веб-сайті Налаштування знаходяться в лівій бічній панелі.\n2. У розділі <b>Налаштування</b> натисніть <b>Підписка</b>.\n3. Потім ви побачите більше інформації, включаючи те, як скасувати або змінити підписку, включаючи вимкнення автоматичного поновлення.\n\nЯкщо ви придбали підписку <em>через мобільний додаток</em>, ви можете керувати своєю підпискою через <a href=\"https://support.apple.com/en-us/HT202039\" target=\"_blank\">Apple App Store</a> або через <a href=\"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en\" target=\"_blank\">Google Play Store</a>.\n\n<b>Про вашу підписку</b>\n\nВам ніколи не буде нараховано плату за підписку, якщо ви явно не придбаєте членство через наш веб-сайт, Apple або Google. Підписки знаходяться під електронною адресою, яку ви використовували під час придбання підписки. Якщо ви не бачите підписку у своєму обліковому записі, це означає, що у вас немає підписки, пов'язаної з електронною адресою, з якою ви зараз увійшли. Можливо, ваша підписка може бути пов'язана з іншою електронною адресою, і в такому випадку вам потрібно вийти з системи та знову увійти під тією електронною адресою, щоб побачити свою підписку."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1211
  override val AUTO_RENEW_OFF_QUESTION = "Я хочу вимкнути автоматичне поновлення."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=252
  override val BACK = "Назад"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=787
  override val BARRE = "Барре"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=759
  override val BARRE_GOOGLE_FIT_DESCRIPTION = "Тренування Барре"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1432
  override val BILLING = "Виставлення рахунків"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1258
  override val BILLING_REFUND = "Платежі - повернення коштів"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=332
  override val BREATHING = "Дихання"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2538
  override val BREATHING_GOOGLE_FIT_DESCRIPTION = "Практика дихальних вправ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=263
  override val CANCEL = "Скасувати"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2564
  override val CANCEL_DOWNLOAD = "Скасувати завантаження"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1470
  override val CANNOT_MERGE_ACCOUNTS_ANSWER = "На жаль, ми не можемо об'єднати ваші облікові записи.\n\nБудь ласка, переконайтеся, що ви увійшли за допомогою електронної пошти, яку ви використовували при покупці підписки, щоб отримати доступ!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1469
  override val CANNOT_MERGE_ACCOUNTS_QUESTION = "У мене більше одного облікового запису. Чи можу я їх об'єднати?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1305
  override val CANT_ACCESS_SUBSCRIPTION_ANSWER = "Ви, ймовірно, випадково створили кілька облікових записів Down Dog. Спробуйте вийти з додатка і увійти знову, використовуючи інші електронні адреси, які ви могли використовувати. Зверніть увагу, що ваша підписка діє у всіх наших додатках і на всіх ваших пристроях (включаючи веб-версію), але ви повинні бути увійшли з тією ж електронною адресою, яку ви використовували для покупки. <em>Зверніть увагу, що Apple, Google і PayPal могли надіслати квитанції на електронну адресу, пов'язану з цими сервісами, а не на електронну адресу, яку ви використовували для входу в Down Dog</em>.\n\nЯкщо ви підписалися через мобільний додаток, використовуючи Apple iTunes або Google Play, спробуйте натиснути <b>Відновити покупку в додатку</b> у меню додатка. Переконайтеся, що ви робите це в тому ж додатку, в якому здійснили початкову покупку.\n\nЯкщо ви підписалися через PayPal і не маєте доступу до своєї підписки, швидше за все, ваш платіж не пройшов. Ви можете перевірити це у своєму обліковому записі PayPal або в Налаштуваннях додатка, де ви побачите підписку, яка триває лише кілька днів. Якщо це так, з вас фактично не було стягнуто плату, і ви можете спробувати здійснити покупку знову, відвідавши наш вебсайт. Можливо, вам буде легше оплатити безпосередньо кредитною карткою, а не через PayPal."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1304
  override val CANT_ACCESS_SUBSCRIPTION_QUESTION = "Я не можу отримати доступ до своєї підписки."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3949
  override val CAST = "Транслювати"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1203
  override val CAST_ANSWER = "Так, ми нещодавно додали підтримку Chromecast у мобільні та веб-додатки!\n\nОсь як використовувати Chromecast у мобільному додатку:\n1. Переконайтеся, що ваш пристрій з підтримкою Chromecast (наприклад, телевізор) увімкнений і підключений до тієї ж WiFi мережі, що й ваш пристрій Android/iOS, а також переконайтеся, що у вас встановлена остання версія додатку.\n2. Почніть практику.\n3. Торкніться екрану, щоб викликати елементи керування, потім натисніть <b>кнопку Chromecast</b> у верхньому правому куті (вона виглядає як прямокутник з трьома чверть-колами в нижньому куті).\n4. Зачекайте до хвилини, поки практика завантажиться на вашому телевізорі, потім натисніть відтворення на вашому пристрої Android/iOS.\n\nА ось як використовувати Chromecast у веб-додатку:\n1. Переконайтеся, що ваш пристрій з підтримкою Chromecast (наприклад, телевізор) увімкнений і підключений до тієї ж WiFi мережі, що й ваш комп'ютер.\n2. Почніть практику у веб-додатку, використовуючи <b>Chrome</b>.\n3. Натисніть <b>кнопку Chromecast</b> у нижньому правому куті (вона виглядає як прямокутник з трьома чверть-колами в нижньому куті).\n4. Зачекайте до хвилини, поки практика завантажиться на вашому телевізорі, потім натисніть відтворення на вашому комп'ютері."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1191
  override val CAST_QUESTION = "Чи підтримуєте ви Chromecast?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1349
  override val CAST_TROUBLESHOOTING_ANSWER = "<b>Якщо ваша КНОПКА CAST не відображається:</b> \n\n1. Почніть практику, потім поставте на паузу. Чи бачите ви кнопку cast (у верхньому правому куті для Android/iOS; у нижньому правому куті для веб-додатку)? Ми показуємо кнопку cast тільки під час практики. \n\n2. Спробуйте транслювати щось інше (наприклад, YouTube) з того ж пристрою. Чи бачите ви тоді кнопку cast? Якщо ні, переконайтеся, що ваш пристрій з підтримкою Chromecast (наприклад, телевізор) увімкнений і знаходиться в тій самій WiFi мережі, що і ваш комп'ютер або пристрій Android/iOS. Якщо ви використовуєте комп'ютер, переконайтеся, що ви використовуєте Chrome. \n\n3. Спробуйте транслювати з іншого пристрою. Якщо ви використовували Android/iOS, спробуйте транслювати з веб-додатку на вашому комп'ютері, і навпаки. \n\n4. Спробуйте вимкнути оптимізацію батареї для додатків Down Dog на вашому телефоні. Це дозволить додатку продовжувати спілкуватися з вашим пристроєм Chromecast, замість переходу в режим енергозбереження через кілька хвилин бездіяльності. \n\n\n<b>Якщо ви \"ПІДКЛЮЧЕНІ\", але відео не відтворюється:</b> \n\nСпочатку переконайтеся, що ви чекаєте достатньо часу, щоб Down Dog завантажився на вашому телевізорі. Завантаження може зайняти до 60 секунд. Під час цього часу ваш телевізор спочатку покаже жовту \"завантажувальну\" смугу внизу, потім екран стане чорним. Ваш телевізор покаже відео, коли воно завершить завантаження. \n\nЯкщо екран вашого телевізора залишається чорним після 60 секунд, або якщо слова \"Down Dog\" з'являються посеред чорного екрану, вийдіть з практики і спробуйте знову. Ви можете перезапустити ту саму практику з вкладки Історія (значок годинника внизу вашого екрану для Android/iOS; у лівій бічній панелі для веб). \n\n\n<b>Якщо ваш cast ВІДКЛЮЧАЄТЬСЯ через кілька хвилин відтворення:</b> \n\n1. Перевірте силу сигналу WiFi. Якщо ваш Chromecast або телефон/комп'ютер має слабкий сигнал, ви можете покращити силу сигналу за допомогою WiFi-розширювача або перемістивши його ближче до вашого маршрутизатора.\n\n2. Вимкніть оптимізацію батареї для додатків Down Dog на вашому телефоні. Це дозволить додатку продовжувати спілкуватися з вашим пристроєм Chromecast, замість переходу в режим енергозбереження через кілька хвилин бездіяльності. \n\n3. Якщо це не вирішує проблему, ви також можете спробувати перезапустити ваш маршрутизатор.\n\n4. Нарешті, спробуйте змінити налаштування збереженого WiFi-з'єднання на вашому телефоні на використання статичної IP-адреси."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1348
  override val CAST_TROUBLESHOOTING_QUESTION = "У мене виникли проблеми з Chromecast."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=997
  override fun CASTING_TO_DEVICE(p0: Any) = "Передача на ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3302
  override val CHALLENGE_EMAIL_NOTIFICATIONS_TEXT = "Електронна пошта"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3470
  override val CHALLENGE_EMAIL_UPDATES_TEXT = "Електронна пошта"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3468
  override val CHALLENGE_ENROLL_CHALLENGE_UPDATES_SUBHEADER = "Оновлення виклику"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3469
  override val CHALLENGE_ENROLL_CHALLENGE_UPDATES_SUBTEXT = "Отримуйте оновлення про спільноту та ваш прогрес у виклику!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3466
  override val CHALLENGE_ENROLL_DAILY_REMINDERS_SUBHEADER = "Щоденні нагадування"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3467
  override val CHALLENGE_ENROLL_DAILY_REMINDERS_SUBTEXT = "Отримуйте нагадування практикуватися щодня у січні!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3809
  override val CHALLENGE_FAQ_A1 = "В: Щоб завершити виклик, ви повинні виконувати практику кожного дня місяця. Ви можете використовувати будь-який додаток Down Dog. Практики повинні бути виконані повністю."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3811
  override val CHALLENGE_FAQ_A2 = "В: Down Dog відстежуватиме ваш прогрес за допомогою календаря на сторінці Подорожі у вашому додатку! Щодня, коли ви практикуєте і бачите дату в календарі синього кольору, це зараховується до вашого прогресу в челенджі."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3814
  override val CHALLENGE_FAQ_A3 = "В: Ми надсилаємо наші щоденні нагадування на основі часу, коли ви займалися попереднього дня. Тому, якщо ви займалися раніше, ніж зазвичай, ви могли випередити нас! Поки ви бачите свої заняття, відображені на календарі на сторінці вашої Подорожі, вони зараховуються до вашого прогресу в челенджі."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3816
  override val CHALLENGE_FAQ_A4 = "В: Ні. Нам дуже шкода, але ми не можемо додати практики до вашої історії, які не були виконані в додатку Down Dog."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3818
  override val CHALLENGE_FAQ_A5 = "В: Якщо ви подорожуєте і змінюєте часові пояси, це може вплинути на вашу серію викликів. Наразі наша система записує вашу історію практик на основі часового поясу, в якому ви перебуваєте під час практики. Це означає, що дати ваших практик будуть відповідати вашому поточному часовому поясу, а не оригінальному. Щоб зберегти вашу серію, ми рекомендуємо практикувати в час, який відповідає вашому оригінальному часовому поясу, коли це можливо."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3820
  override val CHALLENGE_FAQ_A6 = "В: Переможці обираються випадковим чином з групи користувачів, які завершили челендж. Переможців повідомляють індивідуально після завершення челенджу."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3808
  override val CHALLENGE_FAQ_Q1 = "З: Які вимоги?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3810
  override val CHALLENGE_FAQ_Q2 = "З: Як відстежується мій прогрес?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3813
  override val CHALLENGE_FAQ_Q3 = "З: Я підписався на щоденні сповіщення, але сьогодні не отримав жодного, чи щось не так?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3815
  override val CHALLENGE_FAQ_Q4 = "З: Я завершив практику в іншому місці - чи можна додати її до історії в моєму додатку?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3817
  override val CHALLENGE_FAQ_Q5 = "З: Я подорожую під час челенджу. Чи вплине це на щось?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3819
  override val CHALLENGE_FAQ_Q6 = "З: Як обирають та зв'язуються з переможцями мерчу?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3807
  override val CHALLENGE_FAQ_TITLE = "Поширені запитання про виклик Down Dog"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3465
  override val CHALLENGE_NO_MESSAGING_ENABLED_ALERT_TEXT = "Ви вирішили не отримувати жодних повідомлень, тому не будете отримувати жодних оновлень про прогрес або нагадувань від Down Dog щодо виклику."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3471
  override val CHALLENGE_NO_MESSAGING_ENABLED_ALERT_TITLE = "Ви впевнені?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3303
  override val CHALLENGE_PUSH_NOTIFICATIONS_TEXT = "Сповіщення Push"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3317
  override val CHALLENGE_RESUBSCRIBE_TO_EMAILS_ALERT_TEXT = "Увага! Ви раніше відмовилися від отримання електронних листів від Down Dog. Увімкнувши електронну комунікацію в рамках виклику, ми автоматично знову активуємо ваш обліковий запис для отримання електронних листів від нас."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1218
  override val CHANGE_EMAIL_ANSWER = "1. Перейдіть до <b>Налаштування</b>. На мобільному пристрої ви можете потрапити туди, натиснувши три горизонтальні лінії внизу праворуч на екрані. У веб-версії Налаштування знаходяться в лівій бічній панелі.\n2. У розділі <b>Обліковий запис</b> натисніть <b>Електронна пошта</b> і введіть електронну адресу, яку ви хочете використовувати.\n3. Натисніть <b>Зберегти</b>"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1208
  override val CHANGE_EMAIL_QUESTION = "Як змінити електронну адресу, пов'язану з моїм обліковим записом?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=152
  override val CHANGE_LANGUAGE = "Змінити мову"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1159
  override val CHANGE_LANGUAGE_ANSWER = "<b>Йога, Пренатальна йога, Медитація, HIIT</b>\n\nВи можете змінити мову, перейшовши до <b>Налаштування</b> (у мобільному додатку натисніть на 3 горизонтальні лінії внизу праворуч, а в веб-додатку Налаштування будуть на лівій бічній панелі), а потім натисніть <b>Мова</b>!\n\n<b>Барре</b>\n\nНаразі цей додаток доступний лише англійською мовою. Ви все одно будете чути інструкції англійською навіть після зміни мови."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=327
  override val CHANGE_LANGUAGE_NO_INTERNET_MESSAGE = "Ой! Вам потрібно підключитися до Інтернету, щоб змінити мову."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1158
  override val CHANGE_LANGUAGE_QUESTION = "Як змінити мову, яку я чую?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1219
  override val CHANGE_PASSWORD_ANSWER = "1. Перейдіть до <b>Налаштування</b>. На мобільному пристрої ви можете потрапити туди, натиснувши три горизонтальні лінії внизу праворуч на екрані. У веб-версії Налаштування знаходяться в лівій бічній панелі.\n2. У розділі <b>Обліковий запис</b> натисніть <b>Пароль</b> і введіть новий пароль, який ви хочете використовувати, у поля Пароль і Підтвердити пароль.\n3. Натисніть <b>Зберегти</b>.\n\nЯкщо ви забули свій пароль, просто введіть свою електронну адресу та неправильний пароль на екрані входу. Потім натисніть опцію <b>Забули пароль?</b>."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1209
  override val CHANGE_PASSWORD_QUESTION = "Як змінити свій пароль?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1142
  override val CHANGE_PLAYLIST_TYPE_ANSWER = "Ми пропонуємо багато категорій музики і постійно додаємо нові варіанти! У додатку ви можете змінити стиль музики, провівши пальцем вгору по налаштуваннях і натиснувши <b>Музика</b>! У веб-версії ви можете прокрутити налаштування і натиснути на опцію <b>Музика</b>."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1141
  override val CHANGE_PLAYLIST_TYPE_QUESTION = "Як змінити музику?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=52
  override val CHANGE_VISUAL_TYPE_NO_INTERNET_MESSAGE = "Ой! Вам потрібне підключення до Інтернету, щоб змінити візуальні елементи для цієї практики."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1157
  override val CHANGE_VOICE_ANSWER = "<b>Йога, Пренатальна йога, Медитація та HIIT</b>\n\nМи наразі пропонуємо кілька англомовних голосів у цих додатках. На мобільному пристрої ви можете змінити голос, який чуєте, провівши пальцем вгору на головній сторінці налаштувань, а потім натиснувши <b>Голос</b>. У веб-версії ви можете прокрутити налаштування і натиснути опцію <b>Голос</b>.\n\nМи також пропонуємо кілька неангломовних голосів у цих додатках. Ви можете змінити мову, перейшовши до <b>Налаштування</b> (у мобільному додатку натисніть 3 горизонтальні лінії внизу праворуч, а у веб-додатку Налаштування будуть на лівій бічній панелі), а потім натисніть <b>Мова</b>!\n\n<b>Барре</b>\n\nЗараз є лише один голос, але ми плануємо додати додаткові мови та голоси в майбутньому."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1156
  override val CHANGE_VOICE_QUESTION = "Як змінити голос, який я чую?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1441
  override val CHARGED_TWICE = "Мені було стягнуто плату двічі."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1433
  override fun CHECK_OUT_QUESTION(p0: Any) = "Перегляньте наш ${p0}, щоб дізнатися, чи є відповідь на ваше запитання там"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=482
  override val CLEAR_PRACTICE_HISTORY_CONFIRM_MESSAGE = "Ви впевнені, що хочете видалити всі практики з вашої історії практик? Цю дію не можна скасувати."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=275
  override val CLOSE = "Закрийте"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1180
  override val COMMUNITY_ANSWER = "У нас є яскрава та підтримуюча <a href=\"https://www.facebook.com/groups/183894272193568/\" target=\"_blank\">спільнота Down Dog</a> у Facebook, до якої ви можете приєднатися, щоб попросити поради та поділитися своїм прогресом! Ви також можете стежити за нами в <a href=\"https://www.instagram.com/downdogapp/\" target=\"_blank\">Instagram</a>, щоб отримувати поради та спілкуватися з іншими, хто практикує з Down Dog!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1172
  override val COMMUNITY_QUESTION = "Мені так хочеться спільноти під час моєї подорожі! Чи є якась група, до якої я можу приєднатися, щоб отримати підтримку, коли у мене виникають питання?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1394
  override val COMPANIES_FREE_UNTIL_JUNE_1_LONG = "Співробітники, які працюють з дому, мають право на безкоштовне членство до 1 червня!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2563
  override val CONFIRM_CANCEL_OFFLINE_DOWNLOAD = "Ви впевнені, що хочете скасувати це завантаження?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2561
  override val CONFIRM_DELETE_OFFLINE_PRACTICE = "Ви впевнені, що хочете видалити цю офлайн-практику?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=428
  override val CONFIRM_PASSWORD = "Підтвердьте пароль"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1
  override val CONNECT_TO_APPLE_HEALTH = "Підключитися до Apple Health"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=93
  override val CONNECT_TO_GOOGLE_FIT = "Підключитися до Google Fit"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2
  override val CONNECTED_TO_APPLE_HEALTH_MESSAGE = "Ваші заняття тепер автоматично реєструватимуться в Apple Health!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=94
  override val CONNECTED_TO_GOOGLE_FIT_MESSAGE = "Ваші заняття тепер автоматично реєструватимуться в Google Fit!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1009
  override val CONNECTING_TO_CHROMECAST = "Підключення..."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=25
  override val CONNECTION_PROBLEM = "Проблема з підключенням"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=264
  override val CONTACT = "Зв'яжіться"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1421
  override val CONTACT_APPLE_FOR_REFUND = "Якщо ви хочете отримати відшкодування, вам слід звернутися до служби підтримки Apple і повідомити їм, що ми не заперечуємо проти відшкодування."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=265
  override val CONTINUE = "Продовжуйте"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=437
  override val CORPORATE_MEMBERSHIP = "Корпоративне членство"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=616
  override val COUNTDOWN_TIMER = "Таймер зворотного відліку"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2550
  override val CREATE_OFFLINE_PRACTICE = "Створити офлайн практику"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2562
  override val CREATE_OFFLINE_PRACTICE_EXPLANATION = "Створити та завантажити практику з вашими поточними налаштуваннями?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1604
  override val CUSTOM = "Індивідуальний"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=266
  override val DELETE = "Видалити"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=399
  override val DELETE_ACCOUNT = "Видалити обліковий запис"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=487
  override val DELETE_ACCOUNT_AND_STOP_PAYMENTS_CONFIRM_MESSAGE = "Ваш обліковий запис буде НАЗАВЖДИ видалено для ВСІХ додатків Down Dog, і ми автоматично скасуємо вашу підписку. Продовжити?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1220
  override val DELETE_ACCOUNT_ANSWER = "Якщо ви вирішите залишити нас, ви можете видалити свій обліковий запис у мобільному додатку або у веб-додатку. Зверніть увагу, що після видалення вашого облікового запису ви втратите свою платну підписку, а також вашу історію та збережені практики, і це не можна буде відновити!\n\n1. Перейдіть до <b>Налаштування</b>. У мобільному додатку ви можете потрапити туди, натиснувши три горизонтальні лінії внизу праворуч на екрані. У веб-додатку Налаштування знаходяться в лівій бічній панелі.\n2. У розділі <b>Налаштування</b> прокрутіть вниз до <b>Мої дані</b> і натисніть <b>Видалити обліковий запис</b>.\n3. Коли з'явиться спливаюче вікно, натисніть <b>OK</b>."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=485
  override val DELETE_ACCOUNT_CONFIRM_MESSAGE = "Ви впевнені, що хочете видалити свій обліковий запис? Цю дію не можна скасувати. Ваш обліковий запис буде назавжди видалено для всіх додатків Down Dog."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1210
  override val DELETE_ACCOUNT_QUESTION = "Як видалити свій обліковий запис?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1556
  override val DELETE_ACCOUNT_RECONFIRM_MESSAGE = "Ви збираєтеся назавжди видалити свій обліковий запис для ВСІХ додатків Down Dog. ЦЮ ДІЮ НЕ МОЖНА СКАСУВАТИ. Ви хочете продовжити?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=486
  override val DELETE_ACCOUNT_WITHOUT_STOPPING_PAYMENTS_CONFIRM_MESSAGE = "Ваш обліковий запис буде назавжди видалено для ВСІХ додатків Down Dog. Ви ПРОДОВЖИТЕ СПЛАЧУВАТИ за свою підписку, доки не скасуєте її. Продовжити?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=467
  override val DELETE_HISTORY = "Очистити історію практики"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2565
  override val DELETE_OFFLINE_PRACTICE = "Видалити офлайн-практику"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1351
  override val DEVICE_LIMIT_ANSWER = "Так! Обов'язково використовуйте ту саму електронну адресу для входу, яку ви використовували під час підписки."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1306
  override val DEVICE_LIMIT_QUESTION = "Чи дає моя підписка доступ до тренувань на всіх моїх пристроях (ноутбук, телефон, планшет тощо)?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1501
  override val DIDNT_PURCHASE_SUBSCRIPTION = "Ви не придбали підписку."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3946
  override val DISLIKE = "Не подобається"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1502
  override val DONT_SEE_SUBSCRIPTION = "Я не бачу свою підписку"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=629
  override val DOWNLOAD = "Завантажте"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2557
  override val DOWNLOAD_EXPLANATION = "Ви можете знайти цю практику на сторінці Офлайн практик після завершення завантаження."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2559
  override val DOWNLOAD_PRACTICE = "Завантажити практику"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2556
  override val DOWNLOAD_STARTED = "Завантаження розпочато"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2555
  override fun DOWNLOADING_VIDEO_PROGRESS(p0: Any) = "Завантаження... ${p0}%"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3947
  override val EDIT = "Редагувати"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=491
  override val EDIT_EMAIL = "Редагувати електронну пошту"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=628
  override val EDIT_NAME = "Редагувати ім'я"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=492
  override val EDIT_PASSWORD = "Змінити пароль"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=462
  override val EMAIL = "Електронна пошта"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=137
  override val EMAIL_AND_PASSWORD = "Електронна пошта та Пароль"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=197
  override val ENGLISH_POSE_NAMES = "Назви поз англійською"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3370
  override fun ENROLL_CHALLENGE_ENABLE_PUSH_NOTIFICATIONS_INSTRUCTIONS(p0: Any) = "1.  Відкрийте додаток Налаштування.\n                                    \n2.  Перейдіть до розділу Сповіщення.\n                                    \n3.  Знайдіть додаток ${p0} і переконайтеся, що <b>сповіщення увімкнені.</b>"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3304
  override val ENROLL_CHALLENGE_ENABLE_PUSH_NOTIFICATIONS_PROMPT = "Переконайтеся, що у вас увімкнені push-сповіщення для Down Dog на ваших мобільних пристроях."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=146
  override val ENTER_CODE = "Введіть код"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=138
  override val ENTER_EMAIL_ADDRESS = "Введіть адресу електронної пошти"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=139
  override val ENTER_PASSWORD = "Введіть пароль"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2170
  override val EQUIPMENT = "Обладнання"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=88
  override val ERROR_CONNECTING_TO_APPLE_HEALTH_MESSAGE = "Ой! Сталася помилка під час підключення до додатку Health"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=56
  override val ERROR_CONNECTING_TO_GOOGLE_FIT_MESSAGE = "Ой! Сталася помилка під час підключення до Google Fit."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=57
  override val ERROR_OCCURRED_MESSAGE = "Сталася помилка. Будь ласка, зв'яжіться з нами для підтримки."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1198
  override val EXCLUDE_POSES_ANSWER = "<b>Йога</b>\n\nТак! У повних налаштуваннях, у розділі Практика, натисніть <b>Переглянути пози</b>. Тут ви можете \"не подобатися\" пози, і вони будуть виключені з будь-якої майбутньої практики.\n\nНа сторінці <b>Переглянути пози</b> ви також можете \"подобатися\" вибрані пози, що збільшить ймовірність їх появи в майбутніх практиках.\n\nЗверніть увагу, що функція Улюблених і Виключених поз доступна лише для нових типів практик Віньяса, Ресторативна, Ін, Легка та Хатха. Старі типи практик не підтримують цю функцію.\n\nТакож зверніть увагу, що вподобання/невподобання поз вплине на різноманітність.\n\n<b>HIIT</b>\n\nТак! У розділі Практика натисніть <b>Мікс</b>. Звідти натисніть на + зліва від кожної частини тіла, і ви побачите список вправ. Натисніть на конкретні вправи, які ви хочете виключити з вашої практики.\n\n<b>Пренатальна, Барре</b>\n\nМи наразі не маємо цієї функції, але вона безумовно є в нашому списку! Поки що, у мобільному додатку, ви можете пропустити будь-яку позу, яка вам не подобається, провівши пальцем вліво, коли вона з'явиться. У веб-додатку натисніть стрілку вперед у нижньому лівому куті екрану."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1187
  override val EXCLUDE_POSES_QUESTION = "Чи можу я виключити певні пози з моєї практики?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1262
  override val EXERCISE_ADVICE = "Поради щодо вправ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1602
  override val EXERCISE_LIST = "Список Вправ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3254
  override val EXERCISE_NAMES = "Назви вправ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=267
  override val EXIT = "Вийти"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=268
  override val EXIT_PRACTICE = "Вийти з практики"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=156
  override val EXIT_PRACTICE_MESSAGE = "Ви впевнені, що хочете залишити поточну практику?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2720
  override val EXPLICIT_LYRICS = "Відверті тексти"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=280
  override val FACEBOOK = "Фейсбук"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=58
  override val FACEBOOK_AUTHENTICATION_FAILURE_MESSAGE = "Помилка автентифікації через Facebook. Будь ласка, спробуйте пізніше."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=147
  override val FACEBOOK_COMMUNITY = "Спільнота у Facebook"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2552
  override val FAILED_PRACTICE_DOWNLOAD = "Не вдалося завантажити практику"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2568
  override val FAILED_PRACTICE_DOWNLOAD_EXPLANATION = "Щось пішло не так під час завантаження цієї практики. Будь ласка, спробуйте ще раз."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1308
  override val FAMILY_SHARING_ANSWER = "На жаль, ми не підтримуємо Apple Family Sharing."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1307
  override val FAMILY_SHARING_QUESTION = "Чи можу я поділитися своєю підпискою з членами сім'ї?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1434
  override val FAQ_PAGE = "Сторінка поширених запитань (FAQ)"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=269
  override val FAVORITE = "Додати до обраного"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=278
  override val FAVORITES = "Вибране"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1261
  override val FEATURE_REQUEST = "Запит на функцію"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2153
  override val FEEDBACK_OPTIONAL = "Відгук (необов'язково)"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1274
  override val FEEDBACK_SUBMITTED_TEXT = "Дякуємо за ваш лист!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2553
  override val FETCHING_PRACTICE = "Створення практики..."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1417
  override val FITBIT_ANSWER = "Ні."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1416
  override val FITBIT_QUESTION = "Чи підключаються додатки до FitBit?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3957
  override val FOR_YOU = "Для Вас"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=140
  override val FORGOT_PASSWORD = "Забули пароль?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=461
  override val FORGOT_PASSWORD_NEEDS_EMAIL = "Спочатку введіть свою електронну адресу, щоб скинути пароль."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1291
  override val FREE_FOR_HEALTHCARE_WORKERS = "Безкоштовно для медичних працівників"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1110
  override val FREE_FOR_SCHOOLS = "Безкоштовно для шкіл"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1395
  override val GET_COMPANIES_MEMBERSHIP = "Отримати безкоштовне корпоративне членство"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1393
  override val GET_HEALTHCARE_MEMBERSHIP = "Отримати членство для медичних працівників"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1392
  override val GET_STUDENT_MEMBERSHIP = "Отримати студентське членство"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1463
  override val GIFT_ANSWER = "Ні. Наразі ми цього не пропонуємо."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3823
  override val GIFT_INSTRUCTIONS_CONTENT_1 = "Придбайте свій подарунок від Down Dog (або подарунки!)"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3824
  override val GIFT_INSTRUCTIONS_CONTENT_2 = "Отримайте подарунковий сертифікат, який ви можете роздрукувати або надіслати своїм друзям та родині."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3825
  override val GIFT_INSTRUCTIONS_CONTENT_3 = "Отримувачі можуть скористатися QR-кодом у своєму Сертифікаті, щоб розпочати свій рік доступу, коли будуть готові!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3780
  override val GIFT_INSTRUCTIONS_TITLE = "Як це працює:"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1462
  override val GIFT_QUESTION = "Чи можу я подарувати підписку?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1440
  override val GO_TO_APPLE_SUPPORT = "Перейдіть на сторінку підтримки Apple"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1519
  override val GOAL_STREAK_CAPITALIZED = "Серія Досягнень"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1514
  override val GOAL_STREAK_NOT_CAPITALIZED = "Серія досягнень"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=281
  override val GOOGLE = "Гугл"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=60
  override val GOOGLE_AUTHENTICATION_FAILURE_MESSAGE = "Помилка автентифікації Google. Будь ласка, спробуйте пізніше."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1401
  override val GOOGLE_FIT_ANSWER = "На жаль, ми більше не підтримуємо Google Fit.\n\nGoogle внесли деякі зміни, які зробили дуже складним продовження інтеграції Google Fit у наші пропозиції."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1400
  override val GOOGLE_FIT_QUESTION = "Чи підключаються додатки до Google Fit?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1495
  override val GUIDED_MEDITATION_AND_BREATHING_ANSWER = "<b>Йога:</b>\n\n<em>Спробуйте Йога Нідра</em>\n\nВи можете знайти <b>Йога Нідра</b> у додатку для йоги в розділі <b>Тип практики</b>.\n\nПримітка: Йога Нідра - це <b>лише аудіо</b> - відео не буде.\n\nБагатьом людям подобається встановлювати <b>Музику</b> на звуки природи, амбієнт, мозкові хвилі або фортепіано та струни в додатку. Спробуйте кілька варіантів і подивіться, який вам більше подобається!\n\nЯкщо ви новачок у Йога Нідра, ми рекомендуємо слухати її з <b>Типом інструкції</b>, встановленим на <b>Повне пояснення</b> або <b>За замовчуванням</b>.\n\nВи також можете використовувати Йога Нідра, щоб заснути. Після вибору Йога Нідра як типу практики, перейдіть до <b>Підсилення</b> і натисніть <b>Сон</b>!\n\n\n<b>Пренатальна йога:</b>\n\nВстановіть своє <b>Підсилення</b> на <b>Дихання</b>! Це дасть вам кілька дихальних вправ на початку вашої практики, а також керовану медитацію в кінці!\n\n\n<b>Медитація:</b>\n\nУ нас є цілий додаток, присвячений медитації та диханню! Перегляньте його за посиланням <a href='https://meditation.downdogapp.com/download'>Медитація</a>!\n\nЯкщо ви новачок у медитації, щоб отримати найбільше інструкцій, проведіть пальцем вгору по налаштуванням і встановіть <b>Кількість керівництва</b> на <b>Максимум</b>, а <b>Найдовшу тишу</b> на короткий час, наприклад, 30 секунд або 1 хвилину."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1494
  override val GUIDED_MEDITATION_AND_BREATHING_QUESTION = "Як я можу додати більше дихальних вправ і керованої медитації до своєї практики?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=95
  override val HEALTH_DISCLAIMER_AND_WARNING = "Застереження щодо здоров'я та попередження"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=97
  override val HEALTH_WAIVER_TEXT = "* Yoga Buddhi Co. пропонує інформацію про здоров'я та фітнес, призначену виключно для освітніх цілей. Ви не повинні покладатися на інформацію в будь-якому додатку, створеному Yoga Buddhi Co. (включаючи, але не обмежуючись, настільні, мобільні та пристроєві додатки, вебсайти, блоги та будь-які сторінки в соціальних мережах, які підтримуються Yoga Buddhi Co. або Down Dog) як на заміну професійній медичній консультації, діагностиці або лікуванню. Ми жодним чином не гарантуємо і не забезпечуємо точність, повноту або корисність будь-якого контенту, знайденого в будь-якому додатку. Використання будь-якої інформації, наданої в цьому або будь-якому іншому додатку, створеному Yoga Buddhi Co., здійснюється виключно на ваш власний ризик. Ми не несемо відповідальності за травми, отримані під час практики цих технік, і Yoga Buddhi Co. не несе відповідальності за будь-які збитки, обставини, умови або травми, які можуть виникнути прямо або опосередковано внаслідок участі в будь-яких заходах або ідеях, представлених у будь-якому додатку, створеному Yoga Buddhi Co. Практика йоги несе ризик травмування. Ми не рекомендуємо виконувати вправи йоги без належного нагляду, якщо ви вагітні або вам менше 18 років. Використовуючи будь-який додаток, ви приймаєте на себе всю відповідальність за своє здоров'я та будь-які можливі травми або нещасні випадки, які можуть вплинути на ваше благополуччя або здоров'я та/або благополуччя або здоров'я вашої дитини будь-яким чином. Проконсультуйтеся зі своїм лікарем або медичним працівником перед початком будь-якої фітнес-програми або якщо у вас є будь-які питання або занепокоєння щодо вашого здоров'я. Не починайте фітнес-програму, якщо ваш лікар або медичний працівник не рекомендує цього. Якщо ви відчуєте слабкість, запаморочення, біль або задишку в будь-який час під час тренування, ви повинні негайно припинити і звернутися за негайною медичною допомогою."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1391
  override val HEALTHCARE_FREE_UNTIL_JANUARY_1_LONG = "Медичні працівники мають право на безкоштовне членство до 1 червня 2022 року!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1459
  override val HEALTHCARE_MEMBERSHIPS = "Членство в системі охорони здоров'я"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1753
  override val HERE_ARE_YOUR_SETTINGS = "Ось ваші налаштування!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=785
  override val HIIT = "ВІТ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=758
  override val HIIT_GOOGLE_FIT_DESCRIPTION = "Тренування з інтервальними навантаженнями"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=282
  override val HISTORY = "Історія"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1517
  override fun HOURS_SHORT(p0: Any) = "${p0} год."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1176
  override val HOW_MANY_INTRO_LESSONS_ANSWER = "У нашому вступі всього 9 уроків!\n\nЯкщо ви натиснете <b>Тип</b>, ви побачите 3 категорії: Віньяса, Хатха та Відновлювальна.\n\nПотім, після того як ви обрали свій <b>Тип</b>, натисніть номер (<b>1, 2 або 3</b>), щоб виконати відповідний урок. Нумеровані уроки розроблені таким чином, щоб будуватися один на одному, тому ми рекомендуємо починати з 1. Якщо коло має білий фон, це означає, що обрано урок цього Типу."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1168
  override val HOW_MANY_INTRO_LESSONS_QUESTION = "Скільки вступних уроків є?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1475
  override val HOW_TO_CANCEL_ANSWER = "<b>Як керувати або скасувати підписку</b>\n\n<em>Якщо ви придбали підписку на веб-сайті</em>:\n\n1. Перейдіть до <b>Налаштувань</b>. На мобільному пристрої ви можете потрапити туди, натиснувши три горизонтальні лінії внизу праворуч на екрані. На веб-сайті Налаштування знаходяться в лівій бічній панелі.\n2. У розділі <b>Налаштування</b> натисніть <b>Підписка</b>.\n3. Потім ви побачите більше інформації, включаючи те, як скасувати або змінити підписку, включаючи вимкнення автоматичного поновлення.\n\n<em>Якщо ви придбали підписку через мобільний додаток</em>:\n\nВи можете керувати своєю підпискою через <a href=\"https://support.apple.com/en-us/HT202039\" target=\"_blank\">Apple App Store</a> або через <a href=\"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en\" target=\"_blank\">Google Play Store</a>.\n\n<b>Про вашу підписку</b>\n\nВам ніколи не буде нараховано плату за підписку, якщо ви явно не придбаєте членство через наш веб-сайт, Apple або Google. Підписки знаходяться під електронною адресою, яку ви використовували під час придбання підписки. Якщо ви не бачите підписку у своєму обліковому записі, це означає, що у вас немає підписки, пов'язаної з електронною адресою, з якою ви зараз увійшли. Можливо, ваша підписка може бути пов'язана з іншою електронною адресою, і в такому випадку вам потрібно вийти з облікового запису та увійти знову під тією електронною адресою, щоб побачити свою підписку."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1476
  override val HOW_TO_CANCEL_QUESTION = "Я хочу скасувати свою підписку."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=99
  override val I_AGREE = "Я погоджуюсь"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1352
  override val I_HAVE_A_DIFFERENT_QUESTION = "У мене інше питання"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1264
  override val I_HAVE_A_QUESTION_ABOUT = "У мене є ще одне запитання щодо:"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1383
  override val I_STILL_NEED_HELP = "Мені все ще потрібна допомога"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1387
  override val I_WANT_A_REFUND = "Я хочу повернення коштів."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3292
  override val INCLUDE_POSES_ANSWER = "<b>Йога</b>\n\nЗавдяки функції \"Улюблені та Виключені пози\", ви можете \"вподобати\" вибрані пози, що збільшить ймовірність їх появи в майбутніх практиках. У повних налаштуваннях, у розділі <b>Практика</b>, натисніть <b>Перегляд поз</b>. Тут ви можете \"вподобати\" пози, які хочете бачити частіше у своїх практиках.\n\nУ розділі <b>Перегляд поз</b> ви також можете \"не вподобати\" пози, і вони будуть виключені з будь-яких майбутніх практик.\n\nЗверніть увагу, що функція \"Улюблені та Виключені пози\" доступна лише для нових типів практик: Віньяса, Ресторативна, Ін, Легка та Хатха. Старі типи практик не підтримують цю функцію.\n\nТакож зверніть увагу, що вподобання/невподобання поз вплине на різноманітність.\n\n<b>HIIT</b>\n\nТак! У розділі Практика натисніть <b>Мікс</b>. Звідти натисніть на + ліворуч від кожної частини тіла, і ви побачите список вправ. Натисніть на конкретні вправи, які хочете виключити з вашої практики.\n\n<b>Пренатальна йога, Барре</b>\n\nМи поки що не маємо цієї функції, але вона точно є у нашому списку! Поки що, у мобільному додатку, ви можете пропустити будь-яку позу, яка вам не подобається, провівши пальцем вліво, коли вона з'явиться. У веб-додатку натисніть стрілку вперед у нижньому лівому куті екрану."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3291
  override val INCLUDE_POSES_QUESTION = "Чи можу я включити певні пози у свою практику?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=155
  override val INSTAGRAM = "Інстаграм"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=61
  override val INVALID_EMAIL_MESSAGE = "Це не схоже на дійсну електронну адресу. Будь ласка, спробуйте ще раз."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=161
  override val KEEP_TIMELINE_VISIBLE = "Залишити часову шкалу видимою"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=250
  override val LANGUAGE = "Мова"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1426
  override val LATEST_PAYMENT = "Ваш останній платіж був:"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1396
  override val LEARN_MORE = "Дізнатися більше"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=168
  override val LENGTH = "Тривалість"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=254
  override val LESS = "Менше"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1179
  override val LEVEL_ANSWER = "Оскільки всі ми різні, ви можете спробувати перейти на один рівень вище і подивитися, як це відчувається. Деякі дні ви можете захотіти знизити рівень, в інші дні ви можете відчути бажання спробувати щось нове! Найголовніше, слухайте відгуки свого тіла і рухайтеся повільно та контрольовано.\n\n<a href=\"https://www.facebook.com/groups/183894272193568/\" target=\"_blank\">Спільнота у Facebook</a>, доступна через сторінку <b>Налаштування</b> в додатку, є чудовим ресурсом для отримання порад від інших користувачів додатку!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1171
  override val LEVEL_QUESTION = "Коли мені слід перейти на вищий рівень?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=344
  override val LIFETIME = "Довічно"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1465
  override val LIFETIME_ANSWER = "Ні. Наразі ми цього не пропонуємо."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1464
  override val LIFETIME_QUESTION = "Чи можу я придбати довічну підписку?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3945
  override val LIKE = "Подобається"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3047
  override val LIKE_OR_DISLIKE_EXPLANATION = "Оцінюйте пози, щоб покращити ваші майбутні практики"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3199
  override fun LIKED_DISLIKED_COUNT(p0: Any, p1: Any) = "${p0} сподобалося, ${p1} не сподобалося"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2030
  override val LOCK_SCREEN_MEDIA_CONTROLS = "Медіа-контролі на екрані блокування"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1729
  override val LOG_IN = "Увійти"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1407
  override fun LOGGED_IN_AS(p0: Any) = "Ви увійшли як ${p0}."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=310
  override val LOGIN_ERROR = "Помилка входу"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=141
  override val LOGOUT = "Вийти"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=62
  override val LOGOUT_NO_INTERNET_MESSAGE = "Здається, що ви не підключені до Інтернету. Будь ласка, підключіться, щоб змінити облікові записи."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1456
  override fun LOOK_SCHOOL_PAGE(p0: Any) = "Якщо ви студент або вчитель, перегляньте нашу ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1227
  override val LOWER_VIDEO_QUALITY_ANSWER = "Ви можете змінювати різні візуальні типи! Почніть практику, потім призупиніть її. Натисніть на <b>значок шестерні</b> у верхньому правому куті. Натисніть <b>Якість відео</b>. Ви повинні побачити варіанти для відео вищої та нижчої якості. Ця настройка доступна лише в додатках для йоги."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1217
  override val LOWER_VIDEO_QUALITY_QUESTION = "Відео займають занадто багато місця на моєму телефоні."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2158
  override val MAKE_SURE_TO_VOTE_FOR_EVERY_OPTION = "Обов'язково проголосуйте за кожен варіант!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1486
  override val MANAGE_EMAIL_PREFERENCES_ANSWER = "Ми намагаємося не надсилати занадто багато електронних листів, але зверніть увагу, що електронні листи є основним способом, яким ми повідомляємо нашу спільноту про спеціальні розпродажі та нові функції!\n\nВи можете контролювати, чи підписані ви на наші електронні листи, чи відписані від них, перейшовши до <b>Налаштування</b>, а потім прокрутивши вниз до <b>Отримувати рекламні електронні листи</b> і перемикаючи вмикання або вимикання."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1488
  override val MANAGE_EMAIL_PREFERENCES_QUESTION = "Як керувати налаштуваннями електронної пошти?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1161
  override val MAXIMUM_VERBOSITY_ANSWER = "<b>Йога та Пренатальна Йога:</b>\n\nВи можете збільшити кількість розмов, провівши пальцем вгору по налаштуваннях і потім натиснувши на <b>Інструкція</b>. Натисніть <b>Повна</b>, щоб отримати максимальну кількість інструкцій, які ми пропонуємо.\n\n<b>Медитація:</b>\n\nЩоб отримати максимальну кількість інструкцій, встановіть <b>Кількість Керівництва</b> на <b>Найбільше</b> і встановіть <b>Найдовшу Тишу</b> на короткий час, наприклад, 30 секунд або 1 хвилину.\n\n<b>HIIT та Барре:</b>\nНа даний момент ми не пропонуємо можливість змінювати кількість розмов у HIIT та Барре."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1160
  override val MAXIMUM_VERBOSITY_QUESTION = "Я хочу чути якомога більше інструкцій під час виконання поз."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1661
  override val MEDITATION = "Медитація"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1672
  override val MEDITATION_GOOGLE_FIT_DESCRIPTION = "Практика медитації"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1431
  override val MEMBERSHIP_DELAYED_START_ANSWER = "Ні. Підписки починаються відразу після покупки.\n\nЯкщо ви перебуваєте в періоді безкоштовного пробного періоду, можливо, вам варто почекати до його завершення, щоб здійснити покупку. Однак, якщо у нас діє спеціальна акція, це може означати, що ви пропустите найкращу ціну - ми знаємо, що це може ускладнити рішення!\n\nНезалежно від того, чи проводимо ми спеціальну акцію чи ні, наш вебсайт зазвичай пропонує найкращу ціну на той момент, тому обов'язково відвідайте <a href=\"/purchase\">downdogapp.com/purchase</a>, коли будете готові до покупки!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1430
  override val MEMBERSHIP_DELAYED_START_QUESTION = "Чи можу я відкласти дату початку підписки?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=148
  override val MENU = "Меню"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1163
  override val MINIMUM_VERBOSITY_ANSWER = "<b>Йога та Пренатальна Йога:</b>\n\nВи можете зменшити кількість розмов, провівши пальцем вгору по екрану налаштувань, а потім натиснувши на <b>Інструкція</b>. Натисніть <b>Мінімум</b>, щоб отримати найменшу кількість інструкцій, які ми пропонуємо.\n\n<b>Медитація:</b>\n\nЩоб отримати найменшу кількість інструкцій, які ми пропонуємо, проведіть пальцем вгору по екрану налаштувань і встановіть <b>Кількість Керівництва</b> на <b>Мінімум</b>, а <b>Найдовша Тиша</b> на триваліший період, наприклад, 5 хвилин або більше!\n\n<b>HIIT та Барре:</b>\nНа даний момент ми не пропонуємо можливість змінювати кількість розмов у HIIT та Барре."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1162
  override val MINIMUM_VERBOSITY_QUESTION = "Я хочу відключитися і чути якомога менше інструкцій."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=309
  override fun MINUTES(p0: Any) = "${p0} хвилин"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1254
  override fun MINUTES_SHORT(p0: Any) = "${p0} хв."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1610
  override val MINUTES_WITHOUT_NUMBER = "хвилини"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1554
  override val MIRROR_VIDEO = "Дзеркальне відео"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3
  override val MISSING_APPLE_HEALTH_PERMISSIONS_MESSAGE = "Down Dog було додано як джерело в додатку \"Здоров'я\". Однак, щоб почати записувати практики, вам потрібно увімкнути дозвіл на тренування для Down Dog у додатку \"Здоров'я\"."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1583
  override val MIX = "Змішати"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1510
  override val MONDAY = "Понеділок"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=519
  override val MONTH = "місяць"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=377
  override val MONTHLY = "щомісячний"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1290
  override val MONTHLY_CAPITALIZED = "Щомісячний"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1511
  override val MONTHLY_PRACTICES = "Щомісячні практики"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1516
  override fun MONTHLY_TIME(p0: Any) = "Час ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1513
  override val MONTHLY_TIME_PRACTICED = "Щомісячний час практики"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1482
  override val MONTHLY_TO_YEARLY_ANSWER = "Якщо ви вже придбали місячну підписку, але віддаєте перевагу річній підписці, вам потрібно виконати кілька кроків, залежно від того, як ви здійснили поточну покупку.\n\n<em>Якщо ви придбали через наш <b>вебсайт</b> або <b>Google Play</b></em>:\n\nЯкщо ви придбали поточну підписку через веб, перейдіть до <b>Налаштування</b>, а потім до <b>Підписки</b>, щоб скасувати поточну підписку. Якщо ви придбали через Google Play, ви можете скасувати поточну підписку через <a href=\"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en\" target=\"_blank\">Google Play Store</a>. Після скасування поточної підписки ви можете <a href=\"/purchase\">придбати нову підписку через наш вебсайт</a>.\n\nЗверніть увагу, якщо ви вирішите скасувати та придбати знову, ми не зможемо запропонувати вам часткове повернення коштів. У деяких обмежених випадках ви можете мати право на повернення коштів за поточну покупку - ви можете перевірити свою право на повернення, натиснувши \"Я хочу повернення\" на сторінці <a href=\"/support\">Підтримка</a>. Якщо ви маєте право на повернення і успішно подали запит та отримали підтвердження повернення на \"Я хочу повернення\" на сторінці <a href=\"/support\">Підтримка</a>, тоді ваша поточна підписка автоматично скасовується. Потім ви можете <a href=\"/purchase\">придбати нову підписку через наш вебсайт</a>.\n\n<em>Якщо ви придбали підписку через <b>Apple</b></em>:\n\nВам потрібно буде скасувати підписку <a href=\"https://support.apple.com/en-us/HT202039\" target=\"_blank\">через Apple App Store</a>. Зверніть увагу, ми не можемо здійснювати повернення коштів за покупки, зроблені через Apple. Після того, як ви скасуєте поточну підписку через Apple, ви можете <a href=\"/purchase\">придбати нову підписку через наш вебсайт</a>, що зазвичай має найкращу ціну!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1481
  override val MONTHLY_TO_YEARLY_QUESTION = "Я придбав(ла) місячну підписку, але хочу перейти на річну підписку."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=276
  override val MORE = "Більше"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=182
  override val MUSIC = "Музика"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1140
  override val MUSIC_VOLUME_VS_VOICE_ANSWER = "Якщо ви розпочали практику, натиснувши на екран і призупинивши практику, ви можете налаштувати гучність музики та голосу за допомогою <b>повзунка змішування музики/голосу</b>.\n\nПісля того, як ви встановите бажане співвідношення музики та голосу, ви можете використовувати свій пристрій для збільшення або зменшення загальної гучності."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1139
  override val MUSIC_VOLUME_VS_VOICE_QUESTION = "Я не чую голос інструктора! Де регулятор гучності?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=400
  override val MY_DATA = "Мої дані"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=429
  override val NEED_INTERNET_FOR_SONG_PREVIEW_MESSAGE = "Ой! Вам потрібно підключитися до інтернету, щоб прослухати цей попередній перегляд пісні."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3587
  override val NEW_PASSWORD = "Новий пароль"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=9
  override val NEXT = "Далі"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=403
  override val NEXT_PAYMENT = "Наступний платіж"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=483
  override fun NEXT_PAYMENT_SUBTEXT(p0: Any) = "Наступний платіж: ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1499
  override val NIDRA_AUDIO_ONLY_ANSWER = "Йога Нідра є <b>лише аудіо</b> - відео не буде!\n\nЙога Нідра - це глибоко розслаблююча керована медитація. Ви можете знайти її в розділі <b>Тип</b> практики, прокрутіть до самого низу. Багатьом людям подобається встановлювати <b>Музику</b> на Звуки природи, Амбієнт, Мозкові хвилі або Фортепіано та Струни в додатку ... спробуйте кілька варіантів і подивіться, який вам більше подобається!\n\nЯкщо ви новачок у Йозі Нідра, ми рекомендуємо слухати її з <b>Типом інструкції</b> встановленим на <b>Повне пояснення</b> або <b>За замовчуванням</b>.\n\nВи також можете використовувати Йогу Нідра, щоб заснути. Після вибору Йоги Нідра як вашого Типу практики, перейдіть до <b>Підсилення</b> і натисніть <b>Сон</b>!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1498
  override val NIDRA_AUDIO_ONLY_QUESTION = "Відео з моєю практикою Йога Нідра відсутнє."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1472
  override val NO_EXCHANGE_FEES_ANSWER = "Ми не стягуємо жодних комісій за обмін або конвертацію, але ваш банк може це робити, тому обов'язково перевірте у них!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1471
  override val NO_EXCHANGE_FEES_QUESTION = "Чи стягуєте ви комісії за обмін?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=160
  override val NO_FACEBOOK_EMAIL_MESSAGE = "Будь ласка, дозвольте доступ до вашої електронної адреси, щоб увійти через Facebook."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=162
  override val NO_HISTORY_TEXT = "Здається, ви ще не завершили жодного заняття. Проведіть пальцем назад до головного екрана, щоб розпочати своє перше заняття!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=63
  override val NO_INTERNET_MESSAGE = "Ми маємо проблеми зі зв'язком з нашими серверами. Будь ласка, перевірте своє інтернет-з'єднання і спробуйте ще раз."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1497
  override val NO_MUSIC_OFFLINE_ANSWER = "Через ліцензійні обмеження наша музика не буде супроводжувати збережені улюблені, якщо ви офлайн.\n\nЯкщо ви хочете відтворювати власну музику, ви можете зробити це через інші додатки на вашому пристрої. Однак, хоча звукові підказки за замовчуванням встановлені на максимальну гучність на телефонах і планшетах, іноді цього недостатньо, щоб перекрити звук, що йде з Spotify/iTunes/тощо.\n\nУ таких випадках ми рекомендуємо або використовувати зовнішній динамік для відтворення музики, або використовувати веб-версію <a href=\"/web\">downdogapp.com/web</a> на ноутбуці або настільному комп'ютері, з вашою музикою, зменшеною у фоновому режимі."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1496
  override val NO_MUSIC_OFFLINE_QUESTION = "Я офлайн, і в моєму збереженому улюбленому занятті немає музики."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2551
  override val NO_OFFLINE_PRACTICES = "Ви ще не завантажили жодних практик. Ви можете завантажити практики з вашої історії або створити нову тут!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1478
  override val NO_PARTIAL_REFUND_ANSWER = "На жаль, ми не можемо задовольнити запити на часткове або пропорційне повернення коштів.\n\nЯкщо ви вже придбали підписку, але хочете іншу підписку, вам потрібно виконати кілька кроків, залежно від того, як ви здійснили поточну покупку.\n\n<em>Якщо ви придбали через наш <b>вебсайт</b> або <b>Google Play</b></em>:\n\nЯкщо ви придбали поточну підписку через веб, перейдіть до <b>Налаштування</b>, а потім до <b>Підписки</b>, щоб скасувати поточну підписку. Якщо ви придбали через Google Play, ви можете скасувати поточну підписку через <a href=\"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en\" target=\"_blank\">Google Play Store</a>. Після скасування поточної підписки ви можете <a href=\"/purchase\">придбати нову підписку через наш вебсайт</a>.\n\nЗверніть увагу, якщо ви вирішите скасувати та придбати знову, ми не зможемо запропонувати вам часткове повернення коштів. У деяких обмежених випадках ви можете мати право на повернення коштів за поточну покупку - ви можете перевірити свою право на повернення, натиснувши \"Я хочу повернення\" на сторінці <a href=\"/support\">Підтримка</a>. Якщо ви маєте право на повернення і успішно подали запит та отримали підтвердження повернення на \"Я хочу повернення\" на сторінці <a href=\"/support\">Підтримка</a>, тоді ваша поточна підписка автоматично скасовується. Потім ви можете <a href=\"/purchase\">придбати нову підписку через наш вебсайт</a>.\n\n<em>Якщо ви придбали підписку через <b>Apple</b></em>:\n\nВам потрібно буде скасувати підписку <a href=\"https://support.apple.com/en-us/HT202039\" target=\"_blank\">через Apple App Store</a>. Зверніть увагу, ми не можемо задовольнити запити на повернення коштів за покупки, здійснені через Apple. Після того, як ви скасуєте поточну підписку через Apple, ви можете <a href=\"/purchase\">придбати нову підписку через наш вебсайт</a>, що зазвичай має найкращу ціну!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1477
  override val NO_PARTIAL_REFUND_QUESTION = "Чи можу я отримати часткове відшкодування?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=283
  override val NO_PAST_PURCHASES = "Немає попередніх покупок"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=163
  override val NO_PAST_PURCHASES_MESSAGE = "Здається, що ви ще не здійснювали покупок. Будь ласка, зв'яжіться з нами, якщо ви вважаєте, що це помилка."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1454
  override val NO_REFUND_PRACTICED = "Цей платіж не підлягає поверненню, оскільки ви завершили практику після покупки."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1455
  override fun NO_REFUND_TIME(p0: Any) = "Цей платіж не підлягає поверненню, оскільки він був здійснений понад ${p0} днів тому."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=164
  override val NO_SAVED_PRACTICES_TEXT = "Збережіть свої улюблені практики, щоб повторити їх пізніше."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1224
  override val NO_SOUND_ANSWER = "Ось кілька кроків, які ви можете зробити, щоб спробувати отримати звук з додатку:\n\n• Ви впевнилися, що ваш пристрій не вимкнений? Ви можете перевірити це, відтворивши музику або аудіо через інший додаток.\n• Ви перевірили, чи увімкнена гучність у додатку? Після початку практики ви можете налаштувати баланс між музикою та голосом, призупинивши практику, а потім налаштувавши повзунок внизу екрана. Щоб чути і музику, і голос, переконайтеся, що повзунок налаштований приблизно посередині!\n• Ви пробували закрити та знову відкрити додаток?\n• Ви пробували видалити та перевстановити додаток?\n• Ви пробували використовувати веб-версію Down Dog (<a href=\"https://www.downdogapp.com/web\" target=\"_blank\">https://www.downdogapp.com/web</a>), щоб перевірити, чи виникає та сама проблема?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1214
  override val NO_SOUND_QUESTION = "У мене немає звуку."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=10
  override val NO_STRING = "Ні"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1388
  override val NO_SUBSCRIPTIONS_SUPPORT_MESSAGE = "На вашому рахунку немає активних підписок."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=284
  override val NONE = "Жоден"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1483
  override val NOT_FREE_ANSWER = "У вересні 2018 року ми перейшли на нову модель ціноутворення, де ми надаємо людям короткий безкоштовний пробний період з повним доступом до всіх функцій, а після цього потрібна підписка. Ця модель ціноутворення застосовується до всіх наших додатків.\n\n<b>Методи покупки</b>\n\n<a href=\"/purchase\">Покупка через наш вебсайт</a> зазвичай дозволяє отримати найкращу ціну! Ви можете придбати на нашому вебсайті за допомогою <b>кредитної картки</b> або <b>PayPal</b>. Покупка через наш вебсайт надає вам доступ до всього в усіх додатках, так само, як якщо б ви придбали в додатку через Apple або Google.\n\nВи також можете придбати в додатку через Apple або Google. Зверніть увагу, що Apple і Google стягують комісійні збори, тому ціна в додатку зазвичай буде вищою, ніж на нашому вебсайті.\n\nДля покупок, здійснених за межами Сполучених Штатів, ми не стягуємо жодних комісій за обмін, але ваш банк може, тому обов'язково перевірте це з ними!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1468
  override val NOT_FREE_QUESTION = "Я думав, що додаток безкоштовний, чому мене просять придбати підписку?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=285
  override val OK = "добре"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1686
  override fun ONLY_MIX_GROUP(p0: Any) = "Тільки ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=243
  override val OPEN_IN_AMAZON = "Відкрити в Amazon"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=216
  override val OPEN_IN_ITUNES = "Відкрити в iTunes"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=32
  override val OPEN_IN_SPOTIFY = "Відкрити в Spotify"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1257
  override fun OPEN_IN_X(p0: Any) = "Відкрити в ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3948
  override val OPEN_LINK = "Відкрити посилання"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2149
  override fun OPTION_X_OF_Y(p0: Any, p1: Any) = "Варіант ${p0} з ${p1}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=142
  override val OR = "або"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1111
  override val OTHER = "Інше"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1059
  override val OTHER_APPS = "Інші додатки"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=194
  override val PACE = "Темп"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=463
  override val PASSWORD = "Пароль"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=68
  override val PASSWORD_LENGTH_MESSAGE = "Ваш пароль повинен містити щонайменше чотири символи."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=445
  override val PASSWORDS_MUST_MATCH = "Паролі повинні збігатися"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3944
  override val PAUSE = "Призупинити"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=339
  override val PAY_WITH = "Сплатити за допомогою"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=349
  override val PAY_WITH_PAYPAL = "Сплатити за допомогою PayPal"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=480
  override val PAYPAL = "PayPal"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=347
  override val PAYPAL_AUTHORIZATION_ERROR_MESSAGE = "Сталася помилка під час авторизації вашої покупки через PayPal. Будь ласка, спробуйте ще раз через кілька хвилин або зверніться до служби підтримки клієнтів."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1419
  override val PAYMENT_ALREADY_REFUNDED = "Цей платіж вже було повернено."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=165
  override val PAYMENT_CONFIRMED_MESSAGE = "Платіж підтверджено!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1474
  override val PAYMENT_METHODS_ANSWER = "Ось способи, як ви можете придбати підписку!\n\n1) Ви можете придбати через наш вебсайт за допомогою <b>кредитної картки</b> або <b>PayPal</b>.\n\nПридбання через наш вебсайт надає вам доступ до всього в усіх додатках, так само, як якби ви придбали в додатку через Apple або Google. Ціна на нашому вебсайті зазвичай найкраща, оскільки немає комісійних зборів Apple/Google.\n\n2) Ви можете придбати в додатку через Apple або Google.\n\nЗверніть увагу, що Apple і Google стягують комісійні збори, тому ціна в додатку зазвичай буде вищою, ніж на нашому вебсайті.\n\nДля покупок, здійснених за межами Сполучених Штатів, ми не стягуємо жодних обмінних зборів, але ваш банк може, тому обов'язково перевірте це з ними!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1473
  override val PAYMENT_METHODS_QUESTION = "Які способи оплати ви приймаєте?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=465
  override val PAYMENT_PLAN = "План"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=317
  override val PER_MONTH = "на місяць"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=318
  override val PER_YEAR = "на рік"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2539
  override val PILATES = "Пілатес"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2549
  override val PILATES_GOOGLE_FIT_DESCRIPTION = "Тренування з пілатесу"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3943
  override val PLAY = "Відтворити"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=55
  override val PLAY_STORE_PRODUCT_PRICES_MESSAGE = "Помилка отримання цін на продукти з Play Store"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=319
  override val PLAYLIST = "Плейлист"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=72
  override val PLAYLIST_TYPE_BUSY = "Ми зіткнулися з проблемою при зміні типу вашого плейлиста. Спробуйте ще раз через кілька секунд."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=73
  override val PLAYLIST_TYPE_NO_INTERNET_MESSAGE = "Здається, що ви не підключені до інтернету. Будь ласка, підключіться, щоб змінити типи музики."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3049
  override fun POSE_DISLIKED_MESSAGE(p0: Any) = "Ми виключимо ${p0} з ваших майбутніх практик"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1199
  override val POSE_LIBRARY_ANSWER = "Ми наразі не пропонуємо бібліотеку поз, але вона в розробці! Слідкуйте за оновленнями!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1188
  override val POSE_LIBRARY_QUESTION = "Чи пропонуєте ви бібліотеку поз, щоб я міг дізнатися більше про кожну позу?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3048
  override fun POSE_LIKED_MESSAGE(p0: Any) = "Ми додамо більше ${p0} до ваших майбутніх практик"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1532
  override val POSE_LIST = "Список Позицій"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3008
  override val POSE_LIST_DESCRIPTION = "Ознайомтеся з усіма позами нижче та позначте, які з них ви хотіли б бачити більше або менше в майбутніх практиках."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3252
  override val POSE_NAMES = "Назви поз"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3071
  override val POSES = "Пози"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=286
  override val PRACTICE = "Практикуватися"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1275
  override val PRACTICE_FEEDBACK = "Відгук про практику"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=166
  override val PRACTICE_SAVED_CONFIRMATION = "Практика додана до Вибраного!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1515
  override val PRACTICE_STREAK_NOT_CAPITALIZED = "Серія практик"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1293
  override fun PRACTICES_IN_MONTH(p0: Any) = "Практики ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=456
  override val PRENATAL = "Пренатальна йога"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1200
  override val PRENATAL_ANSWER = "Так! У нас є окремий додаток для пренатальної йоги, який включений у всі підписки, і вам варто його перевірити! Ви можете знайти Пренатальну Йогу на <a href=\"https://play.google.com/store/apps/details?id=com.downdogapp.prenatal\" target=\"_blank\">Android</a> та <a href=\"https://apps.apple.com/us/app/prenatal-yoga-down-dog/id1504152442\" target=\"_blank\">iOS</a>, або на <a href=\"https://prenatal.downdogapp.com/web\" target=\"_blank\">prenatal.downdogapp.com/web</a>. Цей додаток дозволить вам налаштувати вашу практику за триместрами. Він також має багато тих самих підсилень, що й наш основний додаток для йоги, плюс деякі спеціальні, специфічні для вагітності."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1189
  override val PRENATAL_QUESTION = "Я вагітна! Чи є варіант для вагітних, який я можу вибрати?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1267
  override val PRENATAL_SHORT = "Пренатальний"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2554
  override fun PREPARING_VIDEO_PROGRESS(p0: Any) = "Підготовка відео... ${p0}% завершено"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2569
  override val PREPARING_VIDEO_WARNING = "Ми готуємо ваше відео. Будь ласка, тримайте додаток відкритим, поки не почнеться завантаження, або поверніться до додатку через кілька хвилин, щоб розпочати завантаження."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1405
  override val PRICE_DIFFERENCE_ANSWER = "<a href=\"/purchase\">Покупка через наш вебсайт</a> дозволяє уникнути комісійних зборів, які зазвичай стягуються Apple або Google, і зазвичай забезпечує найкращу ціну! Ви можете придбати на нашому вебсайті за допомогою <b>кредитної картки</b> або <b>PayPal</b>. Покупка через наш вебсайт дає вам доступ до всього в усіх додатках, так само, як якщо б ви придбали через додаток Apple або Google. Ви можете використовувати веб-підписку на своєму комп'ютері, телефоні та планшеті.\n\nВи також можете придбати підписку через додаток Apple або Google. Зверніть увагу, що Apple і Google стягують комісійні збори, тому ціна в додатку зазвичай буде вищою, ніж на нашому вебсайті.\n\nДля покупок, здійснених за межами Сполучених Штатів, ми не стягуємо жодних обмінних зборів, але ваш банк може, тому обов'язково перевірте це з ними!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1404
  override val PRICE_DIFFERENCE_QUESTION = "Чому ціни в додатку відрізняються від цін на вебсайті? Чи відрізняються членства?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=287
  override val PRIVACY_POLICY = "Політика конфіденційності"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=398
  override val PROMOTIONAL_EMAILS = "Отримувати рекламні електронні листи"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=351
  override fun RECEIPT_SENT_TO_EMAIL_MESSAGE(p0: Any) = "Квитанція буде надіслана на ${p0}."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1461
  override val RECEIPTS_ANSWER = "Після придбання підписки ми надсилаємо квитанцію на електронну адресу, пов'язану з вашою підпискою.\n\nНа жаль, квитанції не можуть бути надіслані повторно. Якщо вам потрібно знайти оригінальну квитанцію, ми рекомендуємо шукати в електронній пошті за темою \"<b>ВАША КВИТАНЦІЯ ВІД DOWN DOG</b>\". Обов'язково перевірте папку зі спамом!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1460
  override val RECEIPTS_QUESTION = "Чи можете ви надіслати мені квитанцію про покупку підписки?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3799
  override val REDEEM = "Отримати"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3798
  override fun REDEEM_GIFT_INSTRUCTIONS(p0: Any, p1: Any) = "Натисніть кнопку нижче, щоб отримати 1 рік безкоштовного доступу до Down Dog! Подарунок (код ${p0}) буде зараховано на ваш обліковий запис ${p1} з дня, коли ви активуєте подарунок."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3797
  override val REDEEM_GIFT_VIEW_TITLE = "Використайте Ваш подарунковий сертифікат Down Dog"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1222
  override val REFUND_ANSWER = "Якщо ви придбали підписку в Інтернеті, ви можете запросити відшкодування через нашу сторінку <a href=\"/support\">підтримки</a>."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1212
  override val REFUND_QUESTION = "Як я можу отримати відшкодування?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1424
  override val REFUNDED_ON_WAY = "Ваше повернення коштів вже в дорозі."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=626
  override val REMOVE_FROM_FAVORITES = "Видалити з обраного"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=625
  override val REMOVE_FROM_HISTORY = "Видалити з історії"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=663
  override val REMOVE_FROM_HISTORY_MESSAGE = "Ви впевнені, що хочете видалити цю практику з вашої історії?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1206
  override val RENAME_FAVORITES_ANSWER = "Так! Називання окремої практики — чудовий спосіб залишатися організованим, і це допоможе вам запам'ятати, чому вона вам сподобалася!\n\nВи можете позначити БУДЬ-ЯКІ практики, знайдені у вашій Історії (незалежно від того, чи є вони улюбленими чи ні). Просто натисніть на практику у вашій Історії та виберіть <b>Редагувати назву</b>."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1194
  override val RENAME_FAVORITES_QUESTION = "Чи можу я назвати свої улюблені практики, щоб не забути, яка з них яка?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3421
  override fun REQUIRED_EMAIL_DOMAIN_ALERT(p0: Any) = "Будь ласка, увійдіть, використовуючи адресу електронної пошти з доменом ${p0}!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1910
  override val RESET = "Скинути"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=154
  override fun RESET_PASSWORD_MESSAGE(p0: Any) = "Посилання для скидання пароля було надіслано на: ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=167
  override val RESUME_PRACTICE = "Продовжити практику"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=169
  override val RESUME_PRACTICE_MESSAGE = "Ви хочете продовжити свою попередню практику?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2245
  override val RUNNING = "Біг"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2255
  override val RUNNING_GOOGLE_FIT_DESCRIPTION = "Тренування бігу з Down Dog"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=66
  override val SAFARI_OR_MOBILE_BROWSER_WARNING_MESSAGE = "Для найкращого досвіду на телефоні або планшеті завантажте додаток з App Store або Play Store. На настільному комп'ютері або ноутбуці використовуйте Chrome для найнадійнішого відтворення."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1480
  override val SALE_PRICE_ANSWER = "Щоразу, коли у нас розпродаж, ви повинні здійснити покупку через наш вебсайт, щоб отримати знижку.\n\nПокупки можна здійснювати на нашому вебсайті за допомогою кредитної картки або PayPal. Для міжнародних транзакцій ми не стягуємо комісії за обмін, але ваш банк може це зробити, тому обов'язково перевірте це з ними!\n\nЯкщо ви вже придбали підписку і хочете скористатися спеціальною пропозицією, вам потрібно буде виконати кілька кроків, залежно від того, як ви здійснили поточну покупку. Зверніть увагу, що покупка підписки набирає чинності негайно після покупки і скасовує будь-яку поточну підписку. Вона не буде додана до кінця вашої поточної підписки.\n\n<em>Якщо ви придбали через наш <b>вебсайт</b> або <b>Google Play</b></em>:\n\nЯкщо ви придбали поточну підписку через веб, перейдіть до <b>Налаштування</b>, а потім до <b>Підписки</b>, щоб скасувати поточну підписку. Якщо ви придбали через Google Play, ви можете скасувати поточну підписку через <a href=\"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en\" target=\"_blank\">Google Play Store</a>. Після скасування поточної підписки ви можете придбати нову підписку.\n\nЗверніть увагу, якщо ви вирішите скасувати та придбати знову, ми не зможемо запропонувати вам часткове повернення коштів. У деяких обмежених випадках ви можете мати право на повернення коштів за поточну покупку - ви можете перевірити свою право на повернення, натиснувши \"Я хочу повернення\" у <a href=\"/support\">Підтримка</a>. Якщо ви маєте право на повернення і успішно запросили та отримали підтвердження повернення у \"Я хочу повернення\" у <a href=\"/support\">Підтримка</a>, тоді ваша поточна підписка автоматично скасовується. Потім ви можете придбати нову підписку.\n\n<em>Якщо ви придбали підписку через <b>Apple</b></em>:\n\nВам потрібно буде скасувати підписку <a href=\"https://support.apple.com/en-us/HT202039\" target=\"_blank\">через Apple App Store</a>. Зверніть увагу, що ми не можемо задовольнити запити на повернення коштів за покупки, здійснені через Apple. Після того, як ви скасуєте поточну підписку через Apple, ви можете придбати нову підписку, яка зазвичай має найкращу ціну!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1479
  override val SALE_PRICE_QUESTION = "Я отримав(-ла) електронний лист про розпродаж! Як отримати ціну зі знижкою?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=198
  override val SANSKRIT_POSE_NAMES = "Назви поз у санскриті"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=454
  override val SAVE = "Зберегти"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=529
  override val SAVE_AND_UNLINK = "Зберегти та Від'єднати"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1204
  override val SAVE_FOR_OFFLINE_ANSWER = "Так! Є кілька способів зберегти практику для використання в режимі офлайн. Зверніть увагу, що це працює лише на мобільних додатках, а не на веб-версії.\n\n<em>Завантажте практику, яку ви ніколи раніше не виконували</em>\n\nНа головному екрані встановіть усі налаштування, які ви хочете мати в практиці, а потім натисніть на <b>стрілку вниз</b> внизу екрана. Це перенесе вас на екран <b>Офлайн-практики</b>. Якщо ви натиснете <b>Створити офлайн-практику</b>, це створить і почне завантажувати нову практику з вашими поточними налаштуваннями.\n\n<em>Завантажте практику, яку ви вже виконували</em>\n\nНа головному екрані натисніть на <b>значок годинника</b> внизу, щоб побачити свою <b>Історію</b> практик. Натисніть на будь-яку практику в цьому списку, а потім прокрутіть вниз і натисніть <b>Завантажити практику</b>.\n\nЗверніть увагу, що це працюватиме лише для практик в Історії, які належать до додатку, який ви зараз використовуєте. Наприклад, якщо ви раніше використовували додаток для медитації для виконання дихальної практики, а зараз використовуєте додаток для йоги для перегляду своєї Історії, дихальна практика, яку ви раніше виконували, з'явиться у вашому списку Історії. Оскільки ця попередня практика належить до іншого додатку, ніж той, який ви зараз переглядаєте, поруч із цією практикою з'явиться маленький синій значок, що відображає, що вона з додатку для медитації. Ви повинні перейти до додатку для медитації та отримати доступ до свого списку Історії звідти, щоб мати можливість завантажити дихальну практику.\n\n<em>Перегляньте завантажену практику</em>\n\nНа головному екрані натисніть на <b>стрілку вниз</b> внизу екрана. Це перенесе вас на екран <b>Офлайн-практики</b>. Будь-яка практика, яку ви бачите, була завантажена і готова до відтворення без підключення до інтернету!\n\nЗверніть увагу, що через обмеження ліцензування наша музика не буде супроводжувати збережені улюблені практики, коли ви будете офлайн."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1192
  override val SAVE_FOR_OFFLINE_QUESTION = "Чи можу я використовувати Down Dog офлайн?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1205
  override val SAVE_TO_FAVORITES_ANSWER = "Так!\n\n<em>Збережіть практику, яку ви щойно завершили</em>\n\nЯкщо ви хочете зберегти практику відразу після її завершення, натисніть <b>Додати до Вибраного</b> на сторінці після практики, і вона буде збережена у вашому <b>Вибраному</b> та додасть значок Серця до вашої практики. Щоб отримати доступ до вашого <b>Вибраного</b>, з сторінки <b>Історія</b> (доступної через значок годинника внизу головного екрана), ви можете натиснути на будь-яку практику в вашій Історії з значком серця або перемкнутися з <b>Усі</b>, щоб побачити лише ваше <b>Вибране</b>.\n\n<em>Збережіть попередню практику з вашої Історії</em>\n\nЯкщо ви хочете зберегти практику, яку ви робили раніше, перейдіть на сторінку <b>Історія</b> (натисніть значок годинника внизу головного екрана). Коли ви там, прокрутіть вниз і натисніть на практику, яку хочете зберегти. Ви побачите слова <b>Додати до Вибраного</b> внизу. Натискання на це збереже практику у вашому <b>Вибраному</b> та додасть значок Серця до вашої практики. Щоб отримати доступ до вашого <b>Вибраного</b>, з сторінки <b>Історія</b>, ви можете натиснути на будь-яку практику в вашій Історії з значком Серця або перемкнутися з <b>Усі</b>, щоб побачити лише ваше <b>Вибране</b>.\n\n<em>Цікавий факт!</em>\n\nВи можете позначити БУДЬ-ЯКІ практики, знайдені у вашій Історії (незалежно від того, чи є вони улюбленими чи ні). Просто натисніть на практику у вашій Історії та виберіть <b>Редагувати назву</b>."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1193
  override val SAVE_TO_FAVORITES_QUESTION = "Чи є спосіб зберегти мої улюблені практики?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1458
  override val SCHOOL_MEMBERSHIPS = "Шкільні підписки"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2150
  override val SCORE = "Оцінка"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2151
  override val SCORE_HATE_IT = "1 (Ненавиджу це)"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2152
  override val SCORE_LOVE_IT = "5 (Дуже подобається)"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3951
  override val SEARCH = "Пошук"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3108
  override val SEARCH_FOR_A_POSE = "Шукати позу"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3286
  override val SEARCH_FOR_AN_EXERCISE = "Шукати вправу"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1601
  override val SEE_EXERCISES_ON_TIMELINE = "Бачити вправи на шкалі часу"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1587
  override val SEE_POSES_ON_TIMELINE = "Показувати пози на шкалі часу"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=270
  override val SELECT = "Виберіть"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=585
  override val SEND = "Надіслати"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=149
  override val SEND_FEEDBACK = "Надіслати відгук"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1406
  override val SENDING_FEEDBACK_FAILED = "Не вдалося надіслати відгук"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2747
  override val SEQUENCE_LENGTH_INVALID = "Вибачте, така тривалість практики неможлива з вашими поточними налаштуваннями. Будь ласка, виберіть іншу тривалість."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=297
  override val SET_PASSWORD = "Встановити пароль"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=430
  override val SETTINGS = "Налаштування"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1177
  override val SETTINGS_FOR_BEGINNERS_ANSWER = "<b>Йога:</b>\n\n<em>Встановіть свій рівень</em>\n\nЯкщо ви новачок у йозі, ми рекомендуємо почати з рівня <b>Початківець 1</b>, який можна знайти в налаштуваннях Практики.\n\n<em>Виберіть тип практики</em>\n\nДля м'якої практики, яка включає стоячі пози, а також пози на підлозі, спробуйте тип практики <b>М'яка</b>.\n\nДля відпочинкової практики, яка включає лише пози на підлозі, спробуйте <b>Відновлювальна</b> або <b>Інь</b>, що дозволить найдовше утримувати пози.\n\nДля швидшої, плавної, більш енергійної практики спробуйте <b>Віньяса</b>.\n\nЯкщо ви хочете менше рухатися, пропустити чатуранги і дозволити теплу наростати, утримуючи пози довше, спробуйте <b>Хатха</b>.\n\n<em>Рівень інструкцій</em>\n\nВстановіть рівень <b>Інструкцій</b> на <b>Повний</b>, щоб отримати найдетальніші інструкції.\n\n<em>Встановіть швидкість переходів і тривалість утримання</em>\n\nЯкщо ви хочете ще більше уповільнити свою практику, ми рекомендуємо налаштувати <b>Швидкість переходів</b> на <b>Найповільнішу</b> і <b>Тривалість утримання</b> на <b>Найдовшу</b>. Зверніть увагу, що старі типи практик не підтримують ці функції.\n\n<em>Подовжте розминку та завершення</em>\n\nДля типів практик Віньяса, Хатха та М'яка налаштуйте <b>Розминку</b> та <b>Завершення</b> на <b>Подовжені</b>. Зверніть увагу, що старі типи практик не підтримують ці функції.\n\n<em>Вподобайте та виключіть пози</em>\nДля типів практик Віньяса, Хатха та М'яка \"вподобайте\" пози, щоб бачити їх частіше у своїй практиці, або \"не вподобайте\" пози, і ви більше їх не побачите.\n\n<b>Пренатальна йога:</b>\n\nЯкщо ви новачок у йозі, ми рекомендуємо почати з рівня <b>Початківець 1</b>, який можна знайти, провівши пальцем вгору в налаштуваннях і переглянувши налаштування Практики.\n\nДля відпочинкової практики ми рекомендуємо почати з <b>Відновлювальної</b>, яка включає лише роботу на підлозі і дозволить найдовше утримувати пози.\n\n<b>Медитація:</b>\n\nЯкщо ви новачок у медитації, ми рекомендуємо залишити <b>Найдовшу тишу</b> досить короткою - за замовчуванням це 2 хвилини, але ви можете скоротити її до 30 секунд, якщо віддаєте перевагу менше тиші і більше керівництва. Ви також можете встановити <b>Кількість керівництва</b> на <b>Найбільше</b>, щоб отримати найбільше інструкцій, які ми пропонуємо!\n\n<b>HIIT</b>\n\nНаші налаштування за замовчуванням - чудове місце для початку!\n\nЯкщо HIIT занадто складний на рівні 1, спробуйте рівень 0! Ви також можете спробувати скоротити час на кожну вправу. Ви можете налаштувати це, провівши пальцем вгору в налаштуваннях і налаштувавши свої налаштування в розділі Практика, де ви можете налаштувати Тривалість вправи. Ви будете здивовані, наскільки велика різниця може бути в 5 або 10 секунд! Ви також можете скоротити тривалість всього тренування і збільшити тривалість кожного відновлення між вправами.\n\nМи пропонуємо два типи практик: <b>Ротація</b> і <b>Прогресія</b>. Виберіть <b>Прогресія</b>, щоб рухатися через різні частини тіла завжди в одному порядку, або виберіть <b>Ротація</b>, щоб рухатися через різні частини тіла, але змінювати порядок у різних практиках!\n\n<b>Барре:</b>\n\nВи можете налаштувати складність, змінюючи тривалість тренування. Досвідчені спортсмени повинні починати з 15 або 20 хвилин і поступово збільшувати час, якщо хочуть додаткового виклику. Якщо ви новачок, можливо, вам варто почати з 5 хвилин щодня або 10 хвилин через день. Продовжуйте, і ви будете готові до довших тренувань у найкоротші терміни!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1169
  override val SETTINGS_FOR_BEGINNERS_QUESTION = "Я не знаю, з чого почати! Які налаштування мені вибрати, щоб отримати найкращий досвід?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1061
  override val SEVEN_MINUTE = "7 хвилин"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=150
  override val SHARE = "Поділитися"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1246
  override val SHARE_PRACTICE_ANSWER = "Після завершення вашої практики, або з вашої <b>Історії</b> чи <b>Вибраного</b>, натисніть <b>Поділитися цією практикою</b>, щоб отримати посилання для поділу цією практикою з вашими друзями.\n\nКоли ваші друзі натиснуть на посилання, вони будуть перенаправлені до додатку, і вони отримають спливаюче повідомлення про збережену практику. Вони повинні натиснути <b>Так</b>, щоб переконатися, що вона збережена у їхньому <b>Вибраному</b>!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1245
  override val SHARE_PRACTICE_QUESTION = "Як я можу поділитися практикою з моїми друзями?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1181
  override val SHARE_THIS_PRACTICE = "Поділитися цією практикою"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1235
  override val SHARED_PRACTICE = "Спільна практика"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3257
  override val SHOW_EXERCISE_NAMES = "Показувати назви вправ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3343
  override val SHOW_LIKE_AND_EXCLUDE_BUTTONS = "Показати кнопки \"Подобається\" та \"Виключити\""
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2085
  override val SHOW_OVERLAY = "Далі"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2082
  override val SHOW_POSE_NAME = "Показати назви поз"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1555
  override val SHOW_SUBTITLES = "Показувати субтитри"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1728
  override val SIGN_UP = "Зареєструватися"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=64
  override val SIGN_UP_LOGIN = "Зареєструватися / Увійти"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=271
  override val SKIP = "Пропустити"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1173
  override val SLOWER_PACE_ANSWER = "<b>Йога:</b>\n\nЄ кілька налаштувань, які ви можете змінити, щоб уповільнити вашу практику - ми рекомендуємо експериментувати з усіма ними!\n\n<em>Швидкість переходу</em>\n\nПроведіть вгору, щоб побачити всі налаштування. У розділі <b>Час</b> натисніть на <b>Швидкість переходу</b> і встановіть її на <b>Найповільніша</b>, щоб мати більше часу для переходу між позами, потім натисніть <b>Вибрати</b>. Зверніть увагу, що старі типи практик не підтримують цю функцію.\n\n<em>Тривалість утримання</em>\n\nПроведіть вгору, щоб побачити всі налаштування. У розділі <b>Час</b> натисніть на <b>Тривалість утримання</b> і встановіть її на <b>Найдовша</b>, щоб мати більше часу в кожній позі, потім натисніть <b>Вибрати</b>. Зверніть увагу, що старі типи практик не підтримують цю функцію.\n\n<em>Розігрів</em> і <em>Завершення</em>\n\nВстановіть ваш <b>Розігрів</b> і <b>Завершення</b> на <b>Розширений</b>. Зверніть увагу, що старі типи практик не підтримують ці функції.\n\n<em>Рівень інструкцій</em>\n\nЩоб отримати більше інструкцій і порад, ви також можете встановити рівень <b>Інструкцій</b> на <b>Повний</b>.\n\n<em>Типи практик</em>\n\nВи також можете спробувати встановити тип вашої практики на <b>М'яка</b> або <b>Хатха</b> замість <b>Віньяса</b>, щоб виключити віньяса-флоу/чатуранги. Або якщо ви хочете ще більше уповільнити практику, встановіть тип вашої практики на <b>Йін</b> або <b>Відновлювальна</b>!\n\n<b>Пренатальна йога:</b>\n\nПроведіть вгору в налаштуваннях і встановіть ваш <b>Темп</b> на <b>Найповільніший</b>, щоб проводити більше часу в кожній позі. Щоб отримати більше інструкцій і порад, ви також можете встановити рівень <b>Інструкцій</b> на <b>Повне пояснення</b>.\n\n<b>HIIT:</b>\n\nВи можете змінити час, проведений на кожну вправу. Проведіть вгору в налаштуваннях і в розділі <b>Практика</b> натисніть на <b>Тривалість вправи</b>. Ви також можете налаштувати час відпочинку між вправами, натиснувши на <b>Відновлення</b>."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1165
  override val SLOWER_PACE_QUESTION = "Як я можу зменшити швидкість своєї практики?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=466
  override val SOCIAL = "Соціальний"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2086
  override val SOMETHING_WENT_WRONG = "Щось пішло не так"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1533
  override val SONG_LIST = "Список Пісень"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=288
  override val SONGS_PLAYED = "Відтворені пісні"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=272
  override val START = "Почніть"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1600
  override val START_PRACTICE = "Почати практику"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=89
  override val START_PRACTICE_NO_INTERNET_MESSAGE = "Здається, що ви не підключені до Інтернету. Будь ласка, підключіться, щоб розпочати нову практику."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2090
  override val START_SHARED_PRACTICE = "Ви хочете розпочати цю спільну практику?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1507
  override val STAT_TYPE_SUBTITLE = "Що б ви хотіли побачити?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1506
  override val STAT_TYPE_TITLE = "Виберіть свою статистику"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1390
  override val STUDENTS_FREE_UNTIL_JANUARY_1_LONG = "Студенти та вчителі мають право на безкоштовне членство!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1268
  override val SUBJECT_COLON = "Тема:"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=273
  override val SUBMIT = "Надіслати"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1266
  override val SUBMITTING = "Надсилається..."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=477
  override val SUBSCRIPTION = "Підписка"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1223
  override val SUBSCRIPTION_RENEWAL_PRICE_ANSWER = "Якщо ви залишаєте автопоновлення увімкненим, то так! Якщо ви вимкнете автопоновлення, у вас буде можливість повторно підписатися за тією ставкою, яка буде доступна, коли ви будете готові до повторної підписки. Зверніть увагу, що для транзакцій, здійснених через Paypal, ви не зможете знову увімкнути автопоновлення після його вимкнення."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1213
  override val SUBSCRIPTION_RENEWAL_PRICE_QUESTION = "Чи поновлюється моя підписка за тією ж ціною, за яку я її придбав?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1389
  override fun SUBSCRIPTIONS_SUPPORT_MESSAGE(p0: Any) = "Ви увійшли як ${p0}. Ось підписки на вашому акаунті:"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1288
  override val SUBTITLES_ANSWER = "Субтитри доступні для кожної мови, яку ми пропонуємо!\n\nУ мобільному додатку:\n1. Почніть практику\n2. Торкніться екрану, а потім натисніть на <b>значок шестерні</b>. Перемкніть <b>Показувати субтитри</b> у положення <b>УВІМК.</b>\n\nУ веб-додатку:\n1. Почніть практику\n2. Натисніть на значок <b>cc</b>, розташований у нижньому правому куті вашого екрану, щоб увімкнути транскрипції\n\nЩоб вимкнути транскрипції, просто натисніть <b>cc</b> ще раз."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1287
  override val SUBTITLES_QUESTION = "Чи є у вас закриті субтитри/субтитри?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=452
  override val SUCCESS = "Успіх"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1509
  override val SUNDAY = "Неділя"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=500
  override val SUPPORT = "Підтримка"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2333
  override val SUPPORT_MANAGE_EXPECTATIONS_TEXT = "Ми дуже маленька компанія і отримуємо тисячі повідомлень щодня, тому не можемо обіцяти відповідь, але ми зробимо все можливе, щоб відповісти вам якомога швидше! Зверніть увагу, що ми надаємо пріоритет повідомленням від платних клієнтів."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1754
  override val SWIPE_DOWN_TO_START_PRACTICING = "Проведіть пальцем вниз, щоб почати практикуватися"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=262
  override val TAP_TO_BEGIN = "Натисніть, щоб почати"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1260
  override val TECH_ISSUES = "Технічні проблеми"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=289
  override val TERMS_OF_USE = "Умови використання"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=303
  override val THANKS = "Дякую"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2157
  override val THANKS_FOR_FILLING_OUT_THE_SURVEY = "Дякуємо за заповнення опитування!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1265
  override val THIS_FORM_FIELD_IS_REQUIRED = "Будь ласка, заповніть це поле"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=615
  override val TIMELINE = "Хронологія"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2050
  override val TOGGLE_SHOW_MORE_SETTINGS = "Перемкнути показати більше налаштувань"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2590
  override val TOO_MANY_DOWNLOADS = "Ви досягли максимальної кількості одночасних завантажень. Будь ласка, зачекайте, поки одне з них завершиться, і спробуйте ще раз."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1248
  override val TOTAL_PRACTICES = "Загальна кількість практик"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1523
  override val TOTAL_PRACTICES_CAPITALIZED = "Загальна Кількість Практик"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1524
  override val TOTAL_PRACTICES_NOT_CAPITALIZED = "Загальна кількість практик"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1252
  override val TOTAL_TIME = "Загальний час"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1521
  override val TOTAL_TIME_CAPITALIZED = "Загальний Час"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1522
  override val TOTAL_TIME_NOT_CAPITALIZED = "Загальний час практики"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1137
  override val TROUBLESHOOTING = "Усунення несправностей"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=251
  override val TRY_AGAIN = "Спробуйте ще раз"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1155
  override val TURN_OFF_MUSIC_ANSWER = "Ви можете вимкнути музику в додатку, провівши пальцем вгору по налаштуваннях і натиснувши <b>Музика</b>, а потім вибравши <b>Немає</b> для типу музики!\n\nЯкщо ви хочете слухати свою музику, ви можете зробити це через інші додатки на вашому пристрої. Однак, хоча звукові підказки за замовчуванням встановлені на максимальну гучність на телефонах і планшетах, іноді цього недостатньо, щоб перекрити звук, що йде з Spotify/iTunes/тощо.\n\nУ таких випадках ми рекомендуємо або використовувати зовнішній динамік для відтворення музики, або використовувати веб-версію (https://www.downdogapp.com/web) на ноутбуці або настільному комп'ютері, з вашою музикою, зменшеною у фоновому режимі."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1154
  override val TURN_OFF_MUSIC_QUESTION = "Я б вважав за краще слухати свою музику під час практики. Як повністю вимкнути музику?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2088
  override val UNABLE_TO_LOAD_PLAYBACK_URL = "Ой, не вдалося завантажити відео"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1276
  override val UNABLE_TO_OPEN_LINKED_PRACTICE = "Пов'язана практика не пов'язана з цим обліковим записом"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=998
  override val UNKNOWN_CAST_RECEIVER_NAME = "невідомий пристрій"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1641
  override val UNLINK_FROM_APPLE = "Від'єднати від Apple"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1642
  override val UNLINK_FROM_APPLE_MESSAGE = "Встановіть пароль, щоб від'єднатися від Apple."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=504
  override val UNLINK_FROM_FACEBOOK = "Від'єднати від Facebook"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=506
  override val UNLINK_FROM_FACEBOOK_MESSAGE = "Встановіть пароль, щоб від'єднатися від Facebook."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=505
  override val UNLINK_FROM_GOOGLE = "Від'єднати від Google"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=507
  override val UNLINK_FROM_GOOGLE_MESSAGE = "Встановіть пароль, щоб від'єднатися від Google."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1398
  override val UNLINK_GOOGLE_FACEBOOK_ANSWER = "1. Перейдіть до <b>Налаштування</b>. На мобільному пристрої ви можете потрапити туди, натиснувши три горизонтальні лінії внизу праворуч на екрані. У веб-версії Налаштування знаходяться в лівій бічній панелі.\n2. У розділі <b>Обліковий запис</b> натисніть <b>Від'єднати від Google</b> (або <b>Від'єднати від Facebook</b>) і введіть новий пароль, який ви хочете використовувати, у поля Пароль і Підтвердити пароль.\n3. Натисніть <b>Зберегти</b>"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1397
  override val UNLINK_GOOGLE_FACEBOOK_QUESTION = "Як я можу від'єднати Google/Facebook і використовувати електронну пошту та пароль замість цього?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=418
  override val UPDATE = "Оновити"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1226
  override val VIDEO_ACCIDENTALLY_MIRRORED_ANSWER = "Якщо вся ваша практика перевернута, переконайтеся, що у вас не ввімкнена функція дзеркального відображення! Ось як це перевірити!\n\nУ мобільному додатку:\n1. Почніть практику\n2. У верхньому правому куті екрана натисніть <b>значок шестерні</b>. Перемикайте <b>дзеркальне відео</b> увімкнено або вимкнено, щоб перевернути дисплей\n\nУ веб-додатку:\n1. Почніть практику\n2. У нижньому правому куті екрана натисніть <b>третій значок зліва</b>, щоб перевернути дисплей"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1216
  override val VIDEO_ACCIDENTALLY_MIRRORED_QUESTION = "Відео відтворюється у зворотному порядку від того, що говорить голос."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1225
  override val VIDEO_FREEZING_ANSWER = "Ось кілька речей, які ви можете спробувати:\n\n1. Видаліть та перевстановіть додаток\n\n2. Переключіться на відео нижчої якості. Почніть практику, потім призупиніть її. Натисніть на <b>значок шестерні</b> у верхньому правому куті. Натисніть <b>Якість відео</b>. Ви повинні побачити варіанти для відео вищої та нижчої якості. Ця налаштування доступна лише в додатках для йоги.\n\n3. Тільки для веб: Спробуйте інший браузер. Down Dog найкраще працює з Safari, Firefox та Chrome."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1215
  override val VIDEO_FREEZING_QUESTION = "Мій екран завис на півдорозі під час практики."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1201
  override val VIDEO_MODEL_ANSWER = "<b>Йога, Пренатальна йога, Барре</b>\n\nНаразі у нас є лише одна модель для кожного з наших додатків. У міру нашого зростання ми хотіли б додати більше варіантів для вас!\n\n<b>HIIT</b>\n\nНаразі ми пропонуємо дві моделі в додатку HIIT!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1190
  override val VIDEO_MODEL_QUESTION = "Чи є більше ніж одна модель, яку я можу переглянути на відео?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=670
  override val VIDEO_QUALITY = "Якість відео"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2558
  override val VIEW_OFFLINE_PRACTICE = "Переглянути офлайн практику"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1491
  override val VIEW_PLAYLIST_ANSWER = "Після завершення практики або з практики на вашій сторінці <b>Історія</b>, натисніть <b>Список пісень</b>, щоб побачити плейлист пісень, які грали під час вашої практики!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1490
  override val VIEW_PLAYLIST_QUESTION = "Які пісні грали під час моєї практики?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3109
  override val VIEW_POSES = "Переглянути пози"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=75
  override val VISUAL_TYPE_NO_INTERNET_MESSAGE = "Здається, що ви не підключені до Інтернету. Будь ласка, підключіться, щоб змінити типи візуалізації."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=290
  override val VOICE = "Голос"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2159
  override val VOICE_ACTOR_NON_ENGLISH_SURVEY_INTRO = "Ми додаємо нових акторів озвучування до додатку і хочемо почути вашу думку! Оцініть кожен з голосів нижче за шкалою від 1 до 5. Будь ласка, ігноруйте будь-які технічні проблеми/якість звуку і зосередьтеся на самому голосі та на тому, наскільки природно звучить переклад!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2154
  override val VOICE_ACTOR_SURVEY_INTRO = "Ми додаємо нових акторів озвучування до додатку і хочемо почути вашу думку! Оцініть кожен з голосів нижче за шкалою від 1 до 5. Будь ласка, ігноруйте будь-які технічні проблеми/якість звуку і зосередьтеся на самому голосі!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1423
  override val WANT_REFUND_CONFIRMATION = "Ви хочете повернути цей платіж? Вашу підписку буде скасовано, і ви негайно втратите доступ."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1508
  override val WEEK_START_TITLE = "Коли має починатися ваш тиждень?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1518
  override val WEEKLY_GOAL = "Щотижнева мета"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1504
  override val WEEKLY_GOAL_SELECTOR_TITLE = "Встановіть щотижневу мету"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1505
  override val WEEKLY_GOAL_SUBTITLE = "Скільки занять ви плануєте проводити щотижня?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=569
  override val WHATS_UP = "Як справи?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1256
  override fun X_PERCENT_COMPLETE(p0: Any) = "${p0}% завершено"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=378
  override val YEARLY = "щорічно"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1289
  override val YEARLY_CAPITALIZED = "Щорічно"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1731
  override val YES_SIGN_UP = "Так, Зареєструватися"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=291
  override val YES_STRING = "Так"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1060
  override val YOGA = "Йога"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=501
  override val YOGA_FOR_BEGINNERS = "Йога для початківців"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=757
  override val YOGA_GOOGLE_FIT_DESCRIPTION = "Практика йоги з Down Dog"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1493
  override val YOGA_NIDRA_INFO_ANSWER = "Йога Нідра — це глибоко розслаблююча керована медитація. У головному додатку для йоги ви можете знайти її в розділі Практика <b>Тип</b>.\n\nПримітка: <b>Йога Нідра — це лише аудіо</b> — відео не буде.\n\nБагатьом людям подобається встановлювати <b>Музику</b> на Звуки природи, Амбієнт, Мозкові хвилі або Фортепіано і струни в додатку. Спробуйте кілька варіантів і подивіться, який вам більше подобається!\n\nЯкщо ви новачок у Йозі Нідра, ми рекомендуємо слухати її з налаштуванням <b>Тип інструкції</b> на <b>Повне пояснення</b> або <b>За замовчуванням</b>.\n\nВи також можете використовувати Йогу Нідра, щоб заснути! Після вибору Йоги Нідра як вашого типу практики, перейдіть до <b>Підсилення</b> і встановіть ваше підсилення на <b>Сон</b>!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1492
  override val YOGA_NIDRA_INFO_QUESTION = "Що таке Йога Нідра?"
}
